<template>
  <!-- NOTE (TEMPLATE) to build a general proposal and use it in the project as a component -->

  <div class="animated fadeIn" v-if="pageLoaded">
    <b-modal
      id="delJudge"
      ref="delJudge"
      header-bg-variant="primary"
      header-text-variant="white"
      class="text-center"
      size="md"
    >
      <template v-slot:modal-header>
        <h4>انقضا داور طرح</h4>
      </template>
      <template v-slot:modal-footer>
        <b-row>
          <b-col cols="1"></b-col>
          <b-col cols="10">
            <!-- NOTE (b-expire) to expiration of the referee -->
            <b-button
              variant="danger"
              size="lg"
              @click="
                delJudge();
                hideModal('delJudge');
              "
              >انقضا</b-button
            >

            <!-- NOTE (b-cancel) to cancel expiration -->
            <b-button
              variant="warning"
              size="lg"
              class="ml-2"
              @click="hideModal('delJudge')"
              >لغو</b-button
            >
          </b-col>
          <b-col cols="1"></b-col>
        </b-row>
      </template>
      آیا از انقضای داوری مطمئن هستید؟
      <br />
      <br />این کار غیر قابل برگشت خواهد بود!
    </b-modal>
    <b-card
      v-if="role == 'referee' && refereeErrorHandler"
      style="border: 0"
      class="shadow p-3 mb-5 bg-white rounded mt-0"
      >با توجه به وضعیت درخواست، داور اجازه دسترسی به اطلاعات را ندارد</b-card
    >
    <b-card v-else style="border: 0" class="mt-0 mb-0">
      <b-card
        v-if="role == 'referee' && proposal.adminToReferee"
        header-bg-variant="danger"
        header-text-variant="white"
        header="پیام ادمین"
        style="border: 0"
        class="shadow p-3 mb-5 bg-white rounded mt-0"
        >{{ proposal.adminToReferee }}</b-card
      >
      <b-card
        v-if="
          role == 'researcher' &&
          (proposal.status == 'نیاز به تکمیل / اصلاح' ||
            proposal.status == 'پیش نویس') &&
          proposal.adminMessage
        "
        header-bg-variant="danger"
        header-text-variant="white"
        header="اصلاحات مورد نیاز"
        style="border: 0"
        class="shadow p-3 mb-5 bg-white rounded mt-0"
        >{{ proposal.adminMessage }}</b-card
      >
      <b-card
        v-if="
          (role == 'admin' || role == 'researcher') &&
          proposal.status == 'رد شده است'
        "
        header-bg-variant="danger"
        header-text-variant="white"
        header="دلایل رد"
        style="border: 0"
        class="shadow p-3 mb-5 bg-white rounded mt-0"
      >
        <li v-for="message in proposal.rejectionIds" :key="message">
          {{ rejectOptions.filter((x) => x.code == message)[0].label }}
        </li>
        <br />
      </b-card>
      <h3>کد پسادکتری: {{ proposal.requestsCode }}</h3>
      <h4 class="text-dark">وضعیت پسادکتری: {{ proposal.status }}</h4>
      <hr />
      <b-button
        style="float: left"
        v-if="tabIndex == 0"
        variant="primary"
        @click="saveDocx('doc')"
      >
        <i class="fa fa-file-word-o"></i>
        دریافت Word
      </b-button>
      <b-tabs pills v-model="tabIndex">
        <b-tab title="چکیده طرح" active lazy>
          <!-- docx -->
          <div v-show="false" id="doc">
            <div class="all" style="text-align: right">
              <h1
                style="
                  display: inline-block;
                  text-align: center;
                  padding: 5px 0;
                  border-bottom: 3px solid black;
                "
              >
                کد پسا دکتری:
                <span
                  style="direction: ltr; font-family: Bahnschrift SemiBold"
                  >{{ proposal.requestsCode }}</span
                >
              </h1>
              <div>
                <h2 style="color: black; direction: rtl">
                  تاریخ خروجی:
                  <span style="direction: ltr">{{
                    proposal.registerDate
                  }}</span>
                </h2>
                <hr />
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  عنوان و حمایت‌های پیشین
                </h2>
                <div>
                  <ul>
                    <li :class="proposal.faSubject ? 'done' : 'required'">
                      <strong>عنوان رساله دکتری: </strong
                      >{{ proposal.faSubject }}
                    </li>
                    <li
                      :class="
                        proposal.initialIsSupported != null
                          ? 'done'
                          : 'required'
                      "
                    >
                      <strong
                        >آیا این طرح از حمایت‌های قبلی ستاد یا سایر نهادها
                        استفاده کرده است؟
                      </strong>

                      {{ proposal.initialIsSupported ? "بله" : "خیر" }}
                    </li>

                    <li
                      v-if="proposal.initialIsSupported"
                      :class="
                        proposal.initialSupportedType ? 'done' : 'required'
                      "
                    >
                      <strong> حمایت ها: </strong
                      >{{
                        proposal.initialSupportedType
                          ? options.filter(
                              (x) => x.value == proposal.initialSupportedType
                            )[0].text
                          : ""
                      }}
                    </li>
                    <li
                      v-if="
                        proposal.initialSupportedType == 'other' &&
                        proposal.initialIsSupported
                      "
                      :class="
                        proposal.initialOtherSupport ? 'done' : 'required'
                      "
                    >
                      <strong>عنوان حمایت دریافتی: </strong>
                      {{ proposal.initialOtherSupport }}
                    </li>
                    <li
                      v-if="proposal.initialIsSupported"
                      :class="
                        proposal.initialSupportDescription ? 'done' : 'required'
                      "
                    >
                      <strong>توضیحات حمایت دریافتی: </strong>
                      {{ proposal.initialSupportDescription }}
                    </li>
                  </ul>
                </div>
              </div>
              <hr />
              <div>
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  اطلاعات اصلی دوره‌
                </h2>
                <div>
                  <ul>
                    <li :class="proposal.faSubject ? 'done' : 'required'">
                      <strong>عنوان به زبان فارسی: </strong
                      >{{ proposal.faSubject }}
                    </li>
                    <li :class="proposal.enSubject ? 'done' : 'required'">
                      <strong>عنوان به زبان انگلیسی: </strong
                      >{{ proposal.enSubject }}
                    </li>
                    <li :class="proposal.universityId ? 'done' : 'required'">
                      <strong>دانشگاه محل اجرای دوره: </strong>
                      {{
                        proposal.universityId
                          ? universities.filter(
                              (x) => x.id == proposal.universityId
                            )[0]
                            ? universities.filter(
                                (x) => x.id == proposal.universityId
                              )[0].text
                            : ""
                          : ""
                      }}
                    </li>
                    <li
                      v-if="proposal.universityId == notUniversity"
                      :class="proposal.otherUniversity ? 'done' : 'required'"
                    >
                      <strong>نام دانشگاه: </strong
                      >{{ proposal.otherUniversity }}
                    </li>
                    <li
                      v-if="proposal.mehvarId != notMehvar"
                      :class="proposal.mehvarId ? 'done' : 'required'"
                    >
                      <strong>محور دوره: </strong>
                      {{
                        proposal.mehvarId
                          ? mehvars.filter((x) => x.id == proposal.mehvarId)[0]
                            ? mehvars.filter(
                                (x) => x.id == proposal.mehvarId
                              )[0].text
                            : ""
                          : ""
                      }}
                    </li>
                    <li
                      v-if="proposal.mehvarId == notMehvar"
                      :class="proposal.mehvarId ? 'done' : 'required'"
                    >
                      <strong>محور دوره: </strong> سایر محورها
                    </li>
                    <li
                      v-if="proposal.mehvarId == notMehvar"
                      :class="proposal.otherMehvars ? 'done' : 'required'"
                    >
                      <strong>نام محور: </strong>{{ proposal.otherMehvars }}
                    </li>
                    <li>
                      <strong>ماهیت دوره: </strong>
                      <ul>
                        <li v-if="proposal.typeStudy">مطالعاتی</li>
                        <li v-if="proposal.typeSystemicDevelopmental">
                          سیستمی و توسعه‌ای
                        </li>
                        <li v-if="proposal.typePractical">کاربردی</li>
                      </ul>
                    </li>
                    <li>
                      <strong>حوزه دوره: </strong>
                      <ul>
                        <li v-if="proposal.zoneMedicine">پزشکی</li>
                        <li v-if="proposal.zoneAgriculture">کشاورزی</li>
                        <li v-if="proposal.zoneEnvironment">محیط زیست</li>
                        <li v-if="proposal.zoneIndustrial">صنعتی</li>
                        <li v-if="proposal.zoneBioComputing">رایانش زیستی</li>
                        <li v-if="proposal.zoneOther">سایر</li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
              <hr />
              <div>
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  اطلاعات پژوهشگر
                </h2>
                <div>
                  <ul>
                    <li :class="proposal.researcherName ? 'done' : 'required'">
                      <strong>نام: </strong>{{ proposal.researcherName }}
                    </li>
                    <li
                      :class="proposal.researcherLastName ? 'done' : 'required'"
                    >
                      <strong>نام خانوادگی: </strong
                      >{{ proposal.researcherLastName }}
                    </li>
                    <li
                      :class="proposal.researcherNatCode ? 'done' : 'required'"
                    >
                      <strong>کدملی: </strong>{{ proposal.researcherNatCode }}
                    </li>
                    <li
                      :class="proposal.researcherMobile ? 'done' : 'required'"
                    >
                      <strong>تلفن همراه: </strong
                      >{{ proposal.researcherMobile }}
                    </li>
                    <li :class="proposal.researcherFax ? 'done' : 'required'">
                      <strong>دورنگار: </strong>{{ proposal.researcherFax }}
                    </li>
                    <li :class="proposal.researcherEmail ? 'done' : 'required'">
                      <strong>پست الکترونیکی: </strong
                      >{{ proposal.researcherEmail }}
                    </li>
                    <li :class="proposal.researcherState ? 'done' : 'required'">
                      <strong>استان: </strong>{{ proposal.researcherState }}
                    </li>
                    <li :class="proposal.researcherCity ? 'done' : 'required'">
                      <strong>شهر: </strong>{{ proposal.researcherCity }}
                    </li>
                    <li
                      :class="
                        proposal.researcherUniversityId ? 'done' : 'required'
                      "
                    >
                      <strong>دانشگاه محل تحصیل: </strong>
                      {{
                        proposal.researcherUniversityId
                          ? universities.filter(
                              (x) => x.id == proposal.researcherUniversityId
                            )[0]
                            ? universities.filter(
                                (x) => x.id == proposal.researcherUniversityId
                              )[0].text
                            : "-"
                          : "-"
                      }}
                    </li>
                    <li
                      :class="
                        proposal.researcherUniversityOther ? 'done' : 'required'
                      "
                      v-if="proposal.researcherUniversityId == notUniversity"
                    >
                      <strong>نام دانشگاه: </strong
                      >{{ proposal.researcherUniversityOther }}
                    </li>
                    <li
                      :class="proposal.researcherPhDField ? 'done' : 'required'"
                    >
                      <strong>رشته تحصیلی مقطع دکتری: </strong
                      >{{ proposal.researcherPhDField }}
                    </li>
                    <li
                      :class="
                        proposal.researcherPhDThesisSubject
                          ? 'done'
                          : 'required'
                      "
                    >
                      <strong>عنوان رساله دکتری: </strong
                      >{{ proposal.researcherPhDThesisSubject }}
                    </li>
                    <li
                      :class="
                        proposal.researcherPhDThesisDefenceDate
                          ? 'done'
                          : 'required'
                      "
                    >
                      <strong>تاریخ دفاع: </strong>
                      <span style="direction: ltr">{{
                        proposal.researcherPhDThesisDefenceDate
                      }}</span>
                    </li>
                    <li
                      :class="
                        proposal.researcherPhDCertificateDate
                          ? 'done'
                          : 'required'
                      "
                    >
                      <strong>تاریخ دریافت مدرک دکتری: </strong>
                      <span style="direction: ltr">{{
                        proposal.researcherPhDCertificateDate
                      }}</span>
                    </li>
                    <li>
                      <strong
                        >مشخصات ۳ مقاله ISI با IF بالاتر از ۱ (در ۳‌سال اخیر): </strong
                      >{{ proposal.researcherArticle ? "دارد" : "ندارد" }}
                      <ul v-if="proposal.researcherArticle">
                        <li>
                          <strong>شناسه دیجیتالی مقاله (اول): </strong>
                          <span
                            style="
                              direction: ltr;
                              font-family: Bahnschrift SemiBold;
                            "
                            >{{ proposal.researcherDoi1 }}</span
                          >
                        </li>
                        <li>
                          <strong>شناسه دیجیتالی مقاله (دوم): </strong>
                          <span
                            style="
                              direction: ltr;
                              font-family: Bahnschrift SemiBold;
                            "
                            >{{ proposal.researcherDoi2 }}</span
                          >
                        </li>
                        <li>
                          <strong>شناسه دیجیتالی مقاله (سوم): </strong>
                          <span
                            style="
                              direction: ltr;
                              font-family: Bahnschrift SemiBold;
                            "
                            >{{ proposal.researcherDoi3 }}</span
                          >
                        </li>
                      </ul>
                    </li>
                    <br />
                    <li>
                      <strong>ثبت اختراع بین‌المللی: </strong
                      >{{
                        proposal.researcherInternationalPatent
                          ? "دارد"
                          : "ندارد"
                      }}
                      <div v-if="proposal.researcherInternationalPatent">
                        <b-row>
                          <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                            <strong>عنوان اختراع: </strong>
                            <span
                              style="
                                direction: ltr;
                                font-family: Bahnschrift SemiBold;
                              "
                              >{{
                                proposal.researcherInternationalPatentTitle
                              }}</span
                            >
                          </b-col>
                          <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                            <strong>سال اختراع: </strong>
                            <span
                              style="
                                direction: ltr;
                                font-family: Bahnschrift SemiBold;
                              "
                              >{{
                                proposal.researcherInternationalPatentYear
                              }}</span
                            >
                          </b-col>
                        </b-row>
                        <b-row class="my-0 py-0">
                          <b-col cols="12">
                            <strong>توضیحات اختراع: </strong>
                            <span
                              style="
                                direction: ltr;
                                font-family: Bahnschrift SemiBold;
                              "
                              >{{
                                proposal.researcherInternationalPatentDescription
                              }}</span
                            >
                          </b-col>
                        </b-row>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <hr />
              <div>
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  اطلاعات مسئول دوره پسا دکتری
                </h2>
                <ul v-if="proposal.supervisors.length">
                  <li
                    :class="proposal.supervisors[0].name ? 'done' : 'required'"
                  >
                    <strong>نام: </strong>{{ proposal.supervisors[0].name }}
                  </li>
                  <li
                    :class="
                      proposal.supervisors[0].lastName ? 'done' : 'required'
                    "
                  >
                    <strong>نام خانوادگی: </strong
                    >{{ proposal.supervisors[0].lastName }}
                  </li>
                  <li
                    :class="
                      proposal.supervisors[0].natCode ? 'done' : 'required'
                    "
                  >
                    <strong>کدملی: </strong
                    >{{ proposal.supervisors[0].natCode }}
                  </li>
                  <li
                    :class="
                      proposal.supervisors[0].mobile ? 'done' : 'required'
                    "
                  >
                    <strong>تلفن همراه: </strong
                    >{{ proposal.supervisors[0].mobile }}
                  </li>
                  <li
                    :class="proposal.supervisors[0].email ? 'done' : 'required'"
                  >
                    <strong>پست الکترونیکی: </strong
                    >{{ proposal.supervisors[0].email }}
                  </li>
                  <li
                    :class="
                      proposal.supervisors[0].position ? 'done' : 'required'
                    "
                  >
                    <strong>سمت: </strong>{{ proposal.supervisors[0].position }}
                  </li>
                  <li
                    :class="
                      proposal.supervisors[0].universityId ? 'done' : 'required'
                    "
                  >
                    <strong>دانشگاه محل تحصیل: </strong>
                    {{
                      universities.filter(
                        (x) => x.id == proposal.supervisors[0].universityId
                      ).length
                        ? universities.filter(
                            (x) => x.id == proposal.supervisors[0].universityId
                          )[0]
                          ? universities.filter(
                              (x) =>
                                x.id == proposal.supervisors[0].universityId
                            )[0].text
                          : "---"
                        : "---"
                    }}
                  </li>
                  <li class="'done'">
                    <strong>دانشگاه محل اشتغال: </strong>
                    {{
                      proposal.supervisors[0].universityJobId
                        ? universities.filter(
                            (x) =>
                              x.id == proposal.supervisors[0].universityJobId
                          )[0]
                          ? universities.filter(
                              (x) =>
                                x.id == proposal.supervisors[0].universityJobId
                            )[0].text
                          : "-"
                        : "-"
                    }}
                  </li>
                  <li
                    :class="
                      proposal.supervisors[0].scienceCommitteeType
                        ? 'done'
                        : 'required'
                    "
                  >
                    <strong>نوع هیئت علمی: </strong
                    >{{ proposal.supervisors[0].scienceCommitteeType }}
                  </li>
                  <li
                    :class="
                      proposal.supervisors[0].lastDegree ? 'done' : 'required'
                    "
                  >
                    <strong>آخرین مدرک تحصیلی: </strong
                    >{{ proposal.supervisors[0].lastDegree }}
                  </li>
                  <li
                    :class="
                      proposal.supervisors[0].phdThesisSubject
                        ? 'done'
                        : 'required'
                    "
                  >
                    <strong>عنوان رساله دکتری: </strong
                    >{{ proposal.supervisors[0].phdThesisSubject }}
                  </li>
                  <li
                    :class="
                      proposal.supervisors[0].academicRank ? 'done' : 'required'
                    "
                  >
                    <strong>مرتبه علمی: </strong
                    >{{ proposal.supervisors[0].academicRank }}
                  </li>
                  <li>
                    <strong
                      >مشخصات ۵ مقاله ISI با IF بالاتر از ۱ (در ۳‌سال اخیر): </strong
                    >{{ proposal.supervisors[0].article ? "دارد" : "ندارد" }}
                    <ul v-if="proposal.supervisors[0].article">
                      <li>
                        <strong>شناسه دیجیتالی مقاله (اول): </strong
                        ><span
                          style="
                            direction: ltr;
                            font-family: Bahnschrift SemiBold;
                          "
                          >{{ proposal.supervisors[0].doi1 }}</span
                        >
                      </li>
                      <li>
                        <strong>شناسه دیجیتالی مقاله (دوم): </strong
                        ><span
                          style="
                            direction: ltr;
                            font-family: Bahnschrift SemiBold;
                          "
                          >{{ proposal.supervisors[0].doi2 }}</span
                        >
                      </li>
                      <li>
                        <strong>شناسه دیجیتالی مقاله (سوم): </strong
                        ><span
                          style="
                            direction: ltr;
                            font-family: Bahnschrift SemiBold;
                          "
                          >{{ proposal.supervisors[0].doi3 }}</span
                        >
                      </li>
                      <li>
                        <strong>شناسه دیجیتالی مقاله (چهارم): </strong
                        ><span
                          style="
                            direction: ltr;
                            font-family: Bahnschrift SemiBold;
                          "
                          >{{ proposal.supervisors[0].doi4 }}</span
                        >
                      </li>
                      <li>
                        <strong>شناسه دیجیتالی مقاله (پنجم): </strong
                        ><span
                          style="
                            direction: ltr;
                            font-family: Bahnschrift SemiBold;
                          "
                          >{{ proposal.supervisors[0].doi5 }}</span
                        >
                      </li>
                    </ul>
                  </li>
                  <br />
                  <li>
                    <strong>ثبت اختراع بین‌المللی: </strong
                    >{{
                      proposal.supervisors[0].internationalPatent
                        ? "دارد"
                        : "ندارد"
                    }}
                    <div v-if="proposal.supervisors[0].internationalPatent">
                      <b-row>
                        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                          <strong>عنوان اختراع: </strong>
                          <span
                            style="
                              direction: ltr;
                              font-family: Bahnschrift SemiBold;
                            "
                            >{{
                              proposal.supervisors[0].internationalPatentTitle
                            }}</span
                          >
                        </b-col>

                        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                          <strong>سال اختراع: </strong>
                          <span
                            style="
                              direction: ltr;
                              font-family: Bahnschrift SemiBold;
                            "
                            >{{
                              proposal.supervisors[0].internationalPatentYear
                            }}</span
                          >
                        </b-col>
                      </b-row>
                      <b-row class="my-0 py-0">
                        <b-col cols="12">
                          <strong>توضیحات اختراع: </strong>
                          <span
                            style="
                              direction: ltr;
                              font-family: Bahnschrift SemiBold;
                            "
                            >{{
                              proposal.supervisors[0]
                                .internationalPatentDescription
                            }}</span
                          >
                        </b-col>
                      </b-row>
                    </div>
                  </li>
                  <br />
                  <li>
                    <strong>{{
                      proposal.supervisors[0].researchFestivals
                        ? "اعضای برگزیده جشنواره های پژوهشی بوده ام"
                        : "اعضای برگزیده جشنواره های پژوهشی نبوده ام"
                    }}</strong>
                  </li>
                  <li
                    v-if="proposal.supervisors[0].researchFestivals"
                    :class="
                      proposal.supervisors[0].researchFestivalsTitle
                        ? 'done'
                        : 'required'
                    "
                  >
                    <strong>عنوان جشنواره: </strong
                    >{{ proposal.supervisors[0].researchFestivalsTitle }}
                  </li>
                  <br />
                  <li>
                    <strong>آیا استاد راهنمای متقاضی هستید؟ </strong
                    >{{ proposal.supervisors[0].notSupervisor ? "خیر" : "بله" }}
                  </li>
                </ul>
              </div>
              <hr />
              <div>
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  مشخصات دوره
                </h2>
                <div>
                  <ul>
                    <li :class="proposal.abstract ? 'done' : 'required'">
                      <strong>چکیده دوره: </strong><br />
                      {{ proposal.abstract }}
                    </li>
                    <li
                      :class="proposal.requestNecessity ? 'done' : 'required'"
                    >
                      <strong
                        >ضرورت اجرای دوره (در جهت دستیابی به اهداف ستاد و یا
                        راهبردها و اقدامات سند توسعه زیست فناوری): </strong
                      ><br />
                      {{ proposal.requestNecessity }}
                    </li>
                    <li :class="proposal.majorGoals ? 'done' : 'required'">
                      <strong>اهداف کلان دوره: </strong><br />
                      {{ proposal.majorGoals }}
                    </li>
                    <li :class="proposal.minorGoals ? 'done' : 'required'">
                      <strong>اهداف خرد دوره: </strong><br />
                      {{ proposal.minorGoals }}
                    </li>
                    <li
                      :class="proposal.benefitsToCountry ? 'done' : 'required'"
                    >
                      <strong>مزایای دیگر برای کشور: </strong><br />
                      {{ proposal.benefitsToCountry }}
                    </li>
                    <li :class="proposal.methodology ? 'done' : 'required'">
                      <strong>روش شناسی (متدولوژی) و مراحل انجام دوره: </strong
                      ><br />
                      {{ proposal.methodology }}
                    </li>
                    <li
                      :class="
                        proposal.requestProducts.length > 0
                          ? 'done'
                          : 'required'
                      "
                      v-if="proposal.requestProducts.length > 0"
                    >
                      <strong
                        >دستاوردهای عینی و خروجی‌های ملموس(محصول/ محصولات و یا
                        خدمات) حاصل از اجرای دوره:
                      </strong>
                      <b-table
                        responsive
                        small
                        show-empty
                        head-variant="dark"
                        :items="proposal.requestProducts"
                        :fields="achievmentFields"
                        empty-text="رکوردی برای نمایش وجود ندارد"
                        class="table table-secondary"
                      >
                        <template v-slot:head()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.label }}
                          </div>
                        </template>
                        <template v-slot:cell()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.value }}
                          </div>
                        </template>
                        <template v-slot:cell(index)="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.index + 1 }}
                          </div>
                        </template>
                      </b-table>
                    </li>
                    <li
                      :class="
                        proposal.executionHistorySimilar ? 'done' : 'required'
                      "
                    >
                      <strong
                        >سابقه اجرائی یا دوره‌های مشابه در ایران یا خارج از كشور
                        (با ذكر ماخذ): </strong
                      ><br />
                      {{ proposal.executionHistorySimilar }}
                    </li>
                    <li
                      :class="
                        proposal.internationalPartners ? 'done' : 'required'
                      "
                    >
                      <strong>شركای بین‌المللی در اجرای دوره : </strong><br />
                      {{ proposal.internationalPartners }}
                    </li>
                    <li
                      :class="
                        proposal.postDocLastSupports ? 'done' : 'required'
                      "
                    >
                      <strong>حمایتهای احتمالی قبلی ستاد از دوره: </strong
                      ><br />
                      {{ proposal.postDocLastSupports }}
                    </li>
                    <li :class="proposal.references ? 'done' : 'required'">
                      <strong>منابع و ماخذ: </strong><br />
                      {{ proposal.references }}
                    </li>
                  </ul>
                </div>
              </div>
              <hr />
              <div>
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  اطلاعات تجاری‌سازی
                </h2>
                <h4 style="font-size: 18px">
                  نوع تجاری‌سازی:
                  {{
                    proposal.commercializingType == "company"
                      ? "شرکت دانش بنیان"
                      : proposal.commercializingType == "accelerator"
                      ? "شتاب‌دهنده"
                      : "فاقد اطلاعات تجاری‌سازی می‌باشد"
                  }}
                </h4>
                <div v-if="proposal.commercializingType == 'company'">
                  <ul>
                    <div v-if="proposal.companyId != notCompany">
                      <li :class="proposal.companyName ? 'done' : 'required'">
                        <strong>نام شرکت دانش بنیان: </strong
                        >{{ proposal.companyName }}
                      </li>
                      <li :class="proposal.companyName ? 'done' : 'required'">
                        <strong>شماره ثبت شرکت: </strong
                        >{{
                          proposal.companyRegistrationNumber
                            ? proposal.companyRegistrationNumber
                            : "-"
                        }}
                      </li>
                      <li :class="proposal.companyName ? 'done' : 'required'">
                        <strong>شناسه ملی شرکت: </strong
                        >{{
                          proposal.companyNationalId
                            ? proposal.companyNationalId
                            : "-"
                        }}
                      </li>
                    </div>
                    <div v-else>
                      <li
                        :class="proposal.otherCompanyName ? 'done' : 'required'"
                      >
                        <strong>نام شرکت دانش بنیان: </strong
                        >{{ proposal.otherCompanyName }}
                      </li>
                      <li
                        :class="
                          proposal.otherCompanyRegistrationNumber
                            ? 'done'
                            : 'required'
                        "
                      >
                        <strong>شماره ثبت شرکت: </strong
                        >{{ proposal.otherCompanyRegistrationNumber }}
                      </li>
                      <li
                        :class="
                          proposal.otherCompanyNationalId ? 'done' : 'required'
                        "
                      >
                        <strong>شناسه ملی شرکت: </strong
                        >{{ proposal.otherCompanyNationalId }}
                      </li>
                    </div>
                    <li :class="proposal.companyProducts ? 'done' : 'required'">
                      <strong>معرفی فناوری یا محصولات شرکت: </strong><br />
                      {{ proposal.companyProducts }}
                    </li>
                    <li
                      :class="proposal.companyContactInfo ? 'done' : 'required'"
                    >
                      <strong
                        >آدرس پستی / شماره تماس/ پست الکترونیک شرکت: </strong
                      ><br />
                      {{ proposal.companyContactInfo }}
                    </li>
                  </ul>
                </div>
                <ul v-else-if="proposal.commercializingType == 'accelerator'">
                  <li>
                    <strong class="text-primary">نام شتاب‌دهنده:</strong>

                    {{ proposal.acceleratorName }}
                  </li>
                </ul>
                <div v-else-if="proposal.commercializingType == 'none'">
                  <div
                    class="d-flex flex-row mb-2"
                    v-if="proposal.commercializingObligation1"
                  >
                    <b-form-checkbox
                      disabled
                      v-model="proposal.commercializingObligation1"
                      @change="reactivity = !reactivity"
                    ></b-form-checkbox
                    ><span class="ps-2">
                      تایید میکنم با انتخاب این گزینه تا قبل از تایید درخواست
                      توسط یکی از شتاب‌دهنده‌ها یا شرکت‌های مجاز، ستاد توسعه
                      زیست فناوری هیچگونه مسئولیتی در قبال درخواست من نخواهد
                      داشت.
                    </span>
                  </div>
                  <div
                    class="d-flex flex-row mb-2"
                    v-if="proposal.commercializingObligation2"
                  >
                    <b-form-checkbox
                      disabled
                      v-model="proposal.commercializingObligation2"
                      @change="reactivity = !reactivity"
                    ></b-form-checkbox>
                    <span class="ps-2">
                      تایید میکنم با انتخاب این گزینه، کلیه اطلاعات شخصی و علمی
                      این درخواست، در اختیار شتاب‌دهنده‌ها و شرکت‌های مجاز قرار
                      خواهد گرفت تا بتوانند با بررسی اطلاعات، درخواست بنده را
                      بررسی و تایید کنند.
                    </span>
                  </div>
                </div>
                <strong style="color: blue"
                  >ملاحظات مربوط به همکاری طرفین، بازار و عایدی دوره
                </strong>
                <li
                  :class="
                    proposal.interactUniversityCenters ? 'done' : 'required'
                  "
                >
                  <strong
                    >نحوه تعامل با دانشگاه یا مراکز و ملاحظات مربوط به حق
                    مالکیت:
                  </strong>
                  <br />
                  {{ proposal.interactUniversityCenters }}
                </li>
                <li :class="proposal.targetMarket ? 'done' : 'required'">
                  <strong>معرفی بازار هدف: </strong><br />{{
                    proposal.targetMarket
                  }}
                </li>
                <li
                  :class="proposal.productSalesForecast ? 'done' : 'required'"
                >
                  <strong>پیش بینی میزان فروش محصول در سه سال اول: </strong
                  ><br />
                  {{ proposal.productSalesForecast }}
                </li>
                <li :class="proposal.employment ? 'done' : 'required'">
                  <strong>میزان اشتغال زایی دوره: </strong><br />{{
                    proposal.employment
                  }}
                </li>
                <li :class="proposal.durationCooperation ? 'done' : 'required'">
                  <strong>برآورد مدت زمان همکاری: </strong
                  >{{ proposal.durationCooperation }}
                </li>
                <li
                  :class="
                    proposal.estimationProductionProjectRevenue
                      ? 'done'
                      : 'required'
                  "
                >
                  <strong>برآورد میزان تولید و عایدی دوره: </strong><br />{{
                    proposal.estimationProductionProjectRevenue
                  }}
                </li>
                <li
                  :class="
                    proposal.competitiveProductsLevelCompetitiveness
                      ? 'done'
                      : 'required'
                  "
                >
                  <strong
                    >محصولات رقیب و میزان رقابت پذیری(مقایسه قیمت) (در صورت
                    وجود): </strong
                  ><br />
                  {{ proposal.competitiveProductsLevelCompetitiveness }}
                </li>
                <li :class="proposal.productAdvantages ? 'done' : 'required'">
                  <strong>مزیت محصول نسبت به موارد مشابه و موجود: </strong
                  ><br />
                  {{ proposal.productAdvantages }}
                </li>
              </div>
              <hr />
              <div>
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  زمان‌بندی دوره
                </h2>
                <div>
                  <strong>زمان شروع: </strong>
                  {{
                    proposal.gantData.length > 0
                      ? moment(
                          new Date(
                            Math.min(
                              ...proposal.gantData.map((x) =>
                                new Date(
                                  moment(x.startDate, "jYYYY/jMM/jDD").format(
                                    "YYYY-MM-DD"
                                  )
                                ).getTime()
                              )
                            )
                          )
                        ).format("jDD/jMM/jYYYY")
                      : ""
                  }}
                  <br />
                  <strong>زمان پایان: </strong>
                  {{
                    proposal.gantData.length > 0
                      ? moment(
                          new Date(
                            Math.max(
                              ...proposal.gantData.map((x) =>
                                new Date(
                                  moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                    "YYYY-MM-DD"
                                  )
                                ).getTime()
                              )
                            )
                          )
                        ).format("jDD/jMM/jYYYY")
                      : ""
                  }}
                  <br />
                  <strong>مدت زمان: </strong>
                  {{
                    proposal.gantData.length > 0
                      ? (Math.max(
                          ...proposal.gantData.map((x) =>
                            new Date(
                              moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        ) -
                          Math.min(
                            ...proposal.gantData.map((x) =>
                              new Date(
                                moment(x.startDate, "jYYYY/jMM/jDD").format(
                                  "YYYY-MM-DD"
                                )
                              ).getTime()
                            )
                          )) /
                          3600 /
                          24 /
                          1000 +
                        " روز"
                      : ""
                  }}
                  <br />
                </div>
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="proposal.gantData"
                  :fields="serviceFieldsDoc"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                </b-table>
              </div>
              <hr />
              <div>
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  هزینه‌ها
                </h2>
                <div v-if="proposal.personnelCosts.length > 0">
                  <h5 class="mt-5 mb-3 text-primary" style="color: blue">
                    هزینه‌های پرسنلی اعم از مجری و همكاران
                  </h5>

                  <!-- NOTE (t-personnelCost2) previous -->
                  <b-table
                    responsive
                    small
                    show-empty
                    head-variant="dark"
                    :items="proposal.personnelCosts"
                    :fields="PersonnelCostField"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary mb-4"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                    <template v-slot:cell(humanResourceCost)="data">
                      <div>
                        {{
                          (
                            parseInt(data.item.perPersonCost) *
                            parseInt(data.item.cooperationHour)
                          ).toLocaleString()
                        }}
                      </div>
                    </template>
                  </b-table>
                  <!-- {{proposal.personnelCosts.map(x=>x.humanResourceCost).reduce((a,b)=>(parseInt(a)+parseInt(b)))}} -->
                  <p>
                    <strong>جمع کل هزینه های پرسنلی: </strong>
                    {{
                      proposal.personnelCosts.length == 0
                        ? 0
                        : proposal.personnelCosts
                            .map(
                              (x) =>
                                parseInt(x.perPersonCost) *
                                parseInt(x.cooperationHour)
                            )
                            .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                            .toLocaleString()
                    }}
                    تومان
                  </p>
                </div>

                <div v-if="proposal.travelExpenses.length > 0">
                  <h5 class="mt-5 mb-3 text-primary" style="color: blue">
                    هزینه مسافرت‌های ضروری (اعم از هزینه بلیط، اسكان، غذا، حمل و
                    نقل، حق مأموریت و ...):
                  </h5>

                  <!-- NOTE (t-tripCost2) previous -->
                  <b-table
                    responsive
                    small
                    show-empty
                    head-variant="dark"
                    :items="proposal.travelExpenses"
                    :fields="tripCostField"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary mb-4"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                  </b-table>
                  <strong>جمع کل مسافرتهای ضروری: </strong>
                  {{
                    proposal.travelExpenses.length == 0
                      ? 0
                      : proposal.travelExpenses
                          .map((x) => x.cost)
                          .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                          .toLocaleString()
                  }}
                  تومان
                </div>
                <div v-if="proposal.purchases.length > 0">
                  <h5 class="mt-5 mb-3 text-primary" style="color: blue">
                    هزینه دستگاه‌ها، وسایل و مواد مورد نیازكه باید از محل اعتبار
                    طرح خریداری شوند:
                  </h5>

                  <!-- NOTE (t-deviceCost2) previous -->
                  <b-table
                    responsive
                    small
                    show-empty
                    head-variant="dark"
                    :items="proposal.purchases"
                    :fields="deviceCostField"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                    <template v-slot:cell(totalPrice)="data">
                      <div>
                        {{
                          (
                            parseInt(data.item.number) *
                            parseInt(data.item.perPrice)
                          ).toLocaleString()
                        }}
                      </div>
                    </template>
                  </b-table>
                  <strong>جمع کل هزینه دستگاه‌ها: </strong>
                  {{
                    proposal.purchases.length == 0
                      ? 0
                      : proposal.purchases
                          .map((x) => parseInt(x.perPrice) * parseInt(x.number))
                          .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                          .toLocaleString()
                  }}
                  تومان
                </div>

                <div v-if="proposal.participationOrganizationBudget.length > 0">
                  <h5 class="mt-5 mb-3 text-primary" style="color: blue">
                    میزان مشارکت سایر موسسات:
                  </h5>

                  <!-- NOTE (t-orgCost2) previous -->
                  <b-table
                    responsive
                    small
                    show-empty
                    head-variant="dark"
                    :items="proposal.participationOrganizationBudget"
                    :fields="OrgCostField"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                  </b-table>
                  <strong>جمع کل مشارکت موسسات: </strong>
                  {{
                    proposal.participationOrganizationBudget.length == 0
                      ? 0
                      : proposal.participationOrganizationBudget
                          .map((x) => x.totalPrice)
                          .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                          .toLocaleString()
                  }}
                  تومان
                </div>
                <div
                  v-show="
                    proposal.otherCosts
                      .map((x) => x.totalPrice)
                      .reduce((a, b) => parseInt(a) + parseInt(b), 0) > 0
                  "
                >
                  <h5 class="mt-5 mb-3 text-primary" style="color: blue">
                    هزینه‌های دیگر:
                  </h5>
                  <!-- NOTE (t-otherCost2) previous -->
                  <b-table
                    responsive
                    small
                    show-empty
                    head-variant="dark"
                    :items="proposal.otherCosts"
                    :fields="otherCostField"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                  </b-table>
                  <p>
                    <strong>جمع کل سایر هزینه‌ها: </strong>
                    {{
                      proposal.otherCosts.length == 0
                        ? 0
                        : proposal.otherCosts
                            .map((x) => x.totalPrice)
                            .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                            .toLocaleString()
                    }}
                    تومان
                  </p>
                </div>
                <h3>
                  <strong>جمع کل هزینه‌ها: </strong>
                  {{
                    (tPrice = (
                      (proposal.personnelCosts.length == 0
                        ? 0
                        : proposal.personnelCosts
                            .map(
                              (x) =>
                                parseInt(x.perPersonCost) *
                                parseInt(x.cooperationHour)
                            )
                            .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                      (proposal.travelExpenses.length == 0
                        ? 0
                        : proposal.travelExpenses
                            .map((x) => x.cost)
                            .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                      (proposal.purchases.length == 0
                        ? 0
                        : proposal.purchases
                            .map(
                              (x) => parseInt(x.perPrice) * parseInt(x.number)
                            )
                            .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                      (proposal.otherCosts.length == 0
                        ? 0
                        : proposal.otherCosts
                            .map((x) => x.totalPrice)
                            .reduce((a, b) => parseInt(a) + parseInt(b), 0))
                    ).toLocaleString())
                  }}
                  تومان
                </h3>
                <h3>
                  <strong>میزان اعتبار مورد نیاز از ستاد زیست فناوری: </strong>
                  {{ computedTotalCost.toLocaleString() }}
                  تومان
                </h3>
              </div>
              <hr />
              <div>
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  تعهدات
                </h2>
                <div>
                  <ul>
                    <li v-if="proposal.promiseArrays[0]">
                      این طرح در مدت زمان اعلام شده در پروپوزال انجام می‌گردد و
                      مسئولیت تاخیر در انجام طرح بر عهده مجری می‌باشد. مدت زمان:
                      {{
                        proposal.gantData.length > 0
                          ? (Math.max(
                              ...proposal.gantData.map((x) =>
                                new Date(
                                  moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                    "YYYY-MM-DD"
                                  )
                                ).getTime()
                              )
                            ) -
                              Math.min(
                                ...proposal.gantData.map((x) =>
                                  new Date(
                                    moment(x.startDate, "jYYYY/jMM/jDD").format(
                                      "YYYY-MM-DD"
                                    )
                                  ).getTime()
                                )
                              )) /
                              3600 /
                              24 /
                              1000 +
                            " روز"
                          : ""
                      }}
                    </li>
                    <li v-if="proposal.promiseArrays[1]">
                      این طرح با بودجه اعلام شده در پروپوزال انجام می‌گردد.
                      هزینه انجام:
                      {{
                        (tPrice = (
                          (proposal.personnelCosts.length == 0
                            ? 0
                            : proposal.personnelCosts
                                .map(
                                  (x) =>
                                    parseInt(x.perPersonCost) *
                                    parseInt(x.cooperationHour)
                                )
                                .reduce(
                                  (a, b) => parseInt(a) + parseInt(b),
                                  0
                                )) +
                          (proposal.travelExpenses.length == 0
                            ? 0
                            : proposal.travelExpenses
                                .map((x) => x.cost)
                                .reduce(
                                  (a, b) => parseInt(a) + parseInt(b),
                                  0
                                )) +
                          (proposal.purchases.length == 0
                            ? 0
                            : proposal.purchases
                                .map(
                                  (x) =>
                                    parseInt(x.perPrice) * parseInt(x.number)
                                )
                                .reduce(
                                  (a, b) => parseInt(a) + parseInt(b),
                                  0
                                )) +
                          (proposal.otherCosts.length == 0
                            ? 0
                            : proposal.otherCosts
                                .map((x) => x.totalPrice)
                                .reduce((a, b) => parseInt(a) + parseInt(b), 0))
                        ).toLocaleString())
                      }}
                      تومان
                    </li>
                    <li v-if="proposal.promiseArrays[2]">
                      کلیه حقوق مادی و معنوی این طرح متعلق به ستاد زیست فناوری
                      می‌باشد.
                    </li>
                    <li v-if="proposal.promiseArrays[3]">
                      توافق بین دانشگاه و صنعت در خصوص دستاوردهای طرح وجود دارد.
                    </li>
                    <li v-if="proposal.promiseArrays[4]">
                      نحوه و مسیر تجاری سازی طرح مشخص است و مستندات ارائه شده
                      است.
                    </li>
                    <li v-if="proposal.promiseArrays[5]">
                      بهره‌بردار نهایی طرح مشخص است و مستندات ارائه شده است. نام
                      بهره‌بردار:
                      {{
                        (proposal.researcherName
                          ? proposal.researcherName
                          : "-") +
                        " " +
                        proposal.researcherLastName
                      }}
                    </li>
                    <li v-if="proposal.promiseArrays[6]">
                      حداقل 1 مقاله ISI معتبر به عنوان خروجی طرح تعهد می‌شود.
                    </li>
                    <li v-if="proposal.promiseArrays[7]">
                      تمامی گزارش‌ها پیشرفت در موعد مقرر مطابق با گانت چارت
                      انجام خواهد شد.
                    </li>
                    <li v-if="proposal.promiseArrays[8]">
                      کلیه گزارش‌ها و خروجی‌ها و دستاوردهای طرح در پایان انجام
                      طرح به ستاد زیست فناوری ارسال و تحویل داده می‌شود.
                    </li>
                    <li v-if="proposal.promiseArrays[9]">
                      کلیه اصلاحات در مورد مقرر و طی 2 هفته توسط مجری انجام و در
                      سایت بارگذاری می‌گردد.
                    </li>
                    <li v-if="proposal.promiseArrays[10]">
                      ثبت اطلاعات در سامانه هیچ تعهدی را برای ستاد ایجاد نمی‌کند
                      و به منزله ثبت درخواست متقاضی است.
                    </li>
                    <li v-if="proposal.promiseArrays[11]">
                      سوابق پژوهشگر با موضوع دوره منطبق است.
                    </li>
                    <li v-if="proposal.promiseArrays[12]">
                      سوابق استاد راهنما با موضوع دوره منطبق است.
                    </li>
                    <li v-if="proposal.promiseArrays[13]">
                      کلیه موارد فوق مورد تایید اینجانب
                      {{
                        (proposal.researcherName
                          ? proposal.researcherName
                          : "-") +
                        " " +
                        proposal.researcherLastName
                      }}
                      به عنوان مجری طرح و همکاران می‌باشد.
                    </li>
                  </ul>
                </div>
              </div>
              <hr />
            </div>
          </div>
          <!-- docx -->
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-1 variant="dark">
                <h5 class="mb-0">عنوان و حمایت‌های پیشین&nbsp;</h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-1"
              accordion="my-accordion"
              role="tabpanel"
              visible
            >
              <b-card-body>
                <b-card-text>
                  <ul>
                    <li>
                      <strong class="text-primary">عنوان به زبان فارسی: </strong
                      >{{ proposal.faSubject }}
                    </li>

                    <li>
                      <strong class="text-primary"
                        >آیا این طرح از حمایت‌های قبلی ستاد یا سایر نهادها
                        استفاده کرده است؟
                      </strong>
                      <b-form-radio-group
                        v-model="proposal.initialIsSupported"
                        disabled
                      >
                        <b-form-radio :value="true">بله</b-form-radio>
                        <b-form-radio :value="false">خیر</b-form-radio>
                      </b-form-radio-group>
                    </li>

                    <li v-if="proposal.initialIsSupported">
                      <strong class="text-primary">حمایت ها: </strong
                      >{{
                        proposal.initialSupportedType
                          ? options.filter(
                              (x) => x.value == proposal.initialSupportedType
                            )[0].text
                          : ""
                      }}
                    </li>
                    <li v-if="proposal.initialSupportedType == 'other'">
                      <strong class="text-primary">عنوان حمایت دریافتی: </strong
                      >{{ proposal.initialOtherSupport }}
                    </li>
                    <li v-if="proposal.initialIsSupported">
                      <strong class="text-primary"
                        >توضیحات حمایت دریافتی: </strong
                      >{{ proposal.initialSupportDescription }}
                    </li>
                  </ul>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1 border-0" role="tab">
              <b-button block v-b-toggle.accordion-2 variant="light">
                <h5 class="mb-0" style="display: inline-block">
                  اطلاعات اصلی دوره‌&nbsp;
                </h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-2"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text class="shadow p-3">
                  <ul>
                    <li>
                      <strong class="text-primary"
                        >عنوان به زبان فارسی:
                      </strong>
                      {{ proposal.faSubject }}
                    </li>
                    <li>
                      <strong class="text-primary"
                        >عنوان به زبان انگلیسی:
                      </strong>
                      {{ proposal.enSubject }}
                    </li>
                    <li>
                      <strong class="text-primary"
                        >دانشگاه محل اجرای دوره:
                      </strong>
                      {{
                        proposal.universityId
                          ? universities.filter(
                              (x) => x.id == proposal.universityId
                            )[0]
                            ? universities.filter(
                                (x) => x.id == proposal.universityId
                              )[0].text
                            : "-"
                          : "-"
                      }}
                    </li>
                    <li v-if="proposal.universityId == notUniversity">
                      <strong class="text-primary">نام دانشگاه: </strong>
                      {{ proposal.otherUniversity }}
                    </li>
                    <li v-if="proposal.mehvarId != notMehvar">
                      <strong class="text-primary">محور دوره: </strong>
                      {{
                        proposal.mehvarId
                          ? mehvars.filter((x) => x.id == proposal.mehvarId)[0]
                            ? mehvars.filter(
                                (x) => x.id == proposal.mehvarId
                              )[0].text
                            : ""
                          : ""
                      }}
                    </li>
                    <li v-if="proposal.mehvarId == notMehvar">
                      <strong class="text-primary">محور دوره:</strong>
                      سایر محورها
                    </li>
                    <li v-if="proposal.mehvarId == notMehvar">
                      <strong class="text-primary">نام محور: </strong
                      >{{ proposal.otherMehvars }}
                    </li>
                    <li>
                      <strong class="text-primary">ماهیت دوره: </strong>
                      <b-form-group disabled>
                        <b-form-checkbox v-model="proposal.typeStudy"
                          >مطالعاتی</b-form-checkbox
                        >
                        <b-form-checkbox
                          v-model="proposal.typeSystemicDevelopmental"
                          >سیستمی و توسعه‌ای</b-form-checkbox
                        >
                        <b-form-checkbox v-model="proposal.typePractical"
                          >کاربردی</b-form-checkbox
                        >
                      </b-form-group>
                    </li>
                    <li>
                      <strong class="text-primary">حوزه دوره: </strong>
                      <b-form-group disabled>
                        <b-form-checkbox v-model="proposal.zoneMedicine"
                          >پزشکی</b-form-checkbox
                        >
                        <b-form-checkbox v-model="proposal.zoneAgriculture"
                          >کشاورزی</b-form-checkbox
                        >
                        <b-form-checkbox v-model="proposal.zoneEnvironment"
                          >محیط زیست</b-form-checkbox
                        >
                        <b-form-checkbox v-model="proposal.zoneIndustrial"
                          >صنعتی</b-form-checkbox
                        >
                        <b-form-checkbox v-model="proposal.zoneBioComputing"
                          >رایانش زیستی</b-form-checkbox
                        >
                        <b-form-checkbox v-model="proposal.zoneOther"
                          >سایر</b-form-checkbox
                        >
                      </b-form-group>
                    </li>
                  </ul>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-3 variant="light">
                <h5 class="mb-0" style="display: inline-block">
                  اطلاعات پژوهشگر
                </h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-3"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text class="shadow p-3">
                  <ul>
                    <li>
                      <strong class="text-primary">نام: </strong
                      >{{ proposal.researcherName }}
                    </li>
                    <li>
                      <strong class="text-primary">نام خانوادگی: </strong
                      >{{ proposal.researcherLastName }}
                    </li>
                    <li>
                      <strong class="text-primary">کدملی:</strong
                      >{{ proposal.researcherNatCode }}
                    </li>
                    <li>
                      <strong class="text-primary">تلفن همراه: </strong
                      >{{ proposal.researcherMobile }}
                    </li>
                    <li>
                      <strong class="text-primary">دورنگار: </strong
                      >{{ proposal.researcherFax }}
                    </li>
                    <li>
                      <strong class="text-primary">پست الکترونیکی: </strong
                      >{{ proposal.researcherEmail }}
                    </li>
                    <li>
                      <strong class="text-primary">استان: </strong
                      >{{ proposal.researcherState }}
                    </li>
                    <li>
                      <strong class="text-primary">شهر: </strong
                      >{{ proposal.researcherCity }}
                    </li>
                    <li>
                      <strong class="text-primary">دانشگاه محل تحصیل: </strong
                      >{{
                        universities.filter(
                          (x) => x.id == proposal.researcherUniversityId
                        ).length
                          ? universities.filter(
                              (x) => x.id == proposal.researcherUniversityId
                            )[0]
                            ? universities.filter(
                                (x) => x.id == proposal.researcherUniversityId
                              )[0].text
                            : "---"
                          : "---"
                      }}
                    </li>
                    <li v-if="proposal.researcherUniversityId == notUniversity">
                      <strong class="text-primary">نام دانشگاه: </strong
                      >{{ proposal.researcherUniversityOther }}
                    </li>
                    <li>
                      <strong class="text-primary"
                        >رشته تحصیلی مقطع دکتری: </strong
                      >{{ proposal.researcherPhDField }}
                    </li>
                    <li>
                      <strong class="text-primary">عنوان رساله دکتری: </strong
                      >{{ proposal.researcherPhDThesisSubject }}
                    </li>
                    <li>
                      <strong class="text-primary">تاریخ دفاع: </strong
                      >{{ proposal.researcherPhDThesisDefenceDate }}
                    </li>
                    <li>
                      <strong class="text-primary"
                        >تاریخ دریافت مدرک دکتری: </strong
                      >{{ proposal.researcherPhDCertificateDate }}
                    </li>
                    <br />
                    <b-form-group disabled>
                      <div class="d-flex" dir="rtl">
                        <b-form-checkbox
                          :value="true"
                          v-model="proposal.researcherArticle"
                        ></b-form-checkbox>
                        <label class="ml-2"
                          ><h6 class="text-primary">
                            مشخصات ۳ مقاله ISI با IF بالاتر از ۱ (در ۳‌سال اخیر)
                          </h6></label
                        >
                      </div>
                    </b-form-group>
                    <div v-if="proposal.researcherArticle">
                      <li>
                        <strong class="text-primary"
                          >شناسه دیجیتالی مقاله (اول):
                        </strong>
                        {{ proposal.researcherDoi1 }}
                      </li>

                      <br />
                      <li>
                        <strong class="text-primary"
                          >شناسه دیجیتالی مقاله (دوم):
                        </strong>
                        {{ proposal.researcherDoi2 }}
                      </li>

                      <br />
                      <li>
                        <strong class="text-primary"
                          >شناسه دیجیتالی مقاله (سوم):
                        </strong>
                        {{ proposal.researcherDoi3 }}
                      </li>
                    </div>
                    <br />
                    <b-form-group disabled>
                      <div class="d-flex" dir="rtl">
                        <b-form-checkbox
                          :value="true"
                          v-model="proposal.researcherInternationalPatent"
                        ></b-form-checkbox>
                        <label class="ml-2"
                          ><h6 class="text-primary">
                            ثبت اختراع بین‌المللی
                          </h6></label
                        >
                      </div>
                    </b-form-group>

                    <div v-if="proposal.researcherInternationalPatent">
                      <b-row>
                        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                          <strong class="text-primary">عنوان اختراع: </strong>
                          {{ proposal.researcherInternationalPatentTitle }}
                        </b-col>
                        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                          <strong class="text-primary">سال اختراع: </strong>
                          {{ proposal.researcherInternationalPatentYear }}
                        </b-col>
                      </b-row>
                      <b-row class="my-0 py-0">
                        <b-col cols="12">
                          <strong class="text-primary">توضیحات اختراع: </strong>
                          {{
                            proposal.researcherInternationalPatentDescription
                          }}
                        </b-col>
                      </b-row>
                    </div>
                  </ul>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-4 variant="warning">
                <h5 class="mb-0" style="display: inline-block">
                  اطلاعات مسئول دوره پسا دکتری
                </h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-4"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text
                  class="shadow p-3"
                  v-if="proposal.supervisors.length"
                >
                  <ul>
                    <li>
                      <strong class="text-primary">نام: </strong
                      >{{ proposal.supervisors[0].name }}
                    </li>
                    <li>
                      <strong class="text-primary">نام خانوادگی: </strong
                      >{{ proposal.supervisors[0].lastName }}
                    </li>
                    <li>
                      <strong class="text-primary">کدملی:</strong
                      >{{ proposal.supervisors[0].natCode }}
                    </li>
                    <li>
                      <strong class="text-primary">تلفن همراه: </strong
                      >{{ proposal.supervisors[0].mobile }}
                    </li>
                    <li>
                      <strong class="text-primary">پست الکترونیکی: </strong
                      >{{ proposal.supervisors[0].email }}
                    </li>
                    <li>
                      <strong class="text-primary">سمت: </strong
                      >{{ proposal.supervisors[0].position }}
                    </li>
                    <li>
                      <strong class="text-primary">دانشگاه محل تحصیل: </strong>
                      {{
                        universities.filter(
                          (x) => x.id == proposal.supervisors[0].universityId
                        ).length
                          ? universities.filter(
                              (x) =>
                                x.id == proposal.supervisors[0].universityId
                            )[0]
                            ? universities.filter(
                                (x) =>
                                  x.id == proposal.supervisors[0].universityId
                              )[0].text
                            : "---"
                          : "---"
                      }}
                    </li>
                    <li
                      v-if="
                        proposal.supervisors[0].universityId == notUniversity
                      "
                    >
                      <strong class="text-primary">نام دانشگاه: </strong
                      >{{ proposal.supervisors[0].universityOther }}
                    </li>
                    <li>
                      <strong class="text-primary">دانشگاه محل اشتغال: </strong>
                      {{
                        proposal.supervisors[0].universityJobId
                          ? universities.filter(
                              (x) =>
                                x.id == proposal.supervisors[0].universityJobId
                            )[0]
                            ? universities.filter(
                                (x) =>
                                  x.id ==
                                  proposal.supervisors[0].universityJobId
                              )[0].text
                            : "-"
                          : "-"
                      }}
                    </li>
                    <li
                      v-if="
                        proposal.supervisors[0].universityJobId == notUniversity
                      "
                    >
                      <strong class="text-primary">نام دانشگاه: </strong
                      >{{ proposal.supervisors[0].universityJobOther }}
                    </li>
                    <li>
                      <strong class="text-primary">نوع هیئت علمی: </strong>
                      {{ proposal.supervisors[0].scienceCommitteeType }}
                    </li>
                    <li>
                      <strong class="text-primary">آخرین مدرک تحصیلی: </strong>
                      {{ proposal.supervisors[0].lastDegree }}
                    </li>
                    <li>
                      <strong class="text-primary">عنوان رساله دکتری: </strong>
                      {{ proposal.supervisors[0].phdThesisSubject }}
                    </li>
                    <li>
                      <strong class="text-primary">مرتبه علمی: </strong
                      >{{ proposal.supervisors[0].academicRank }}
                    </li>
                  </ul>
                  <b-form-group disabled>
                    <div class="d-flex" dir="rtl">
                      <b-form-checkbox
                        :value="true"
                        v-model="proposal.supervisors[0].article"
                      ></b-form-checkbox>
                      <label class="ml-2"
                        ><h6 class="text-primary">
                          مشخصات ۵ مقاله ISI با IF بالاتر از ۱ (در ۳‌سال اخیر)
                        </h6></label
                      >
                    </div>
                  </b-form-group>
                  <div v-if="proposal.supervisors[0].article">
                    <li>
                      <strong class="text-primary"
                        >شناسه دیجیتالی مقاله (اول):
                      </strong>
                      {{ proposal.supervisors[0].doi1 }}
                    </li>

                    <br />
                    <li>
                      <strong class="text-primary"
                        >شناسه دیجیتالی مقاله (دوم):
                      </strong>
                      {{ proposal.supervisors[0].doi2 }}
                    </li>

                    <br />
                    <li>
                      <strong class="text-primary"
                        >شناسه دیجیتالی مقاله (سوم):
                      </strong>
                      {{ proposal.supervisors[0].doi3 }}
                    </li>

                    <br />
                    <li>
                      <strong class="text-primary"
                        >شناسه دیجیتالی مقاله (چهارم):
                      </strong>
                      {{ proposal.supervisors[0].doi4 }}
                    </li>

                    <br />
                    <li>
                      <strong class="text-primary"
                        >شناسه دیجیتالی مقاله (پنجم):
                      </strong>
                      {{ proposal.supervisors[0].doi5 }}
                    </li>
                  </div>
                  <br />
                  <b-form-group>
                    <div class="d-flex" dir="rtl">
                      <b-form-checkbox
                        :value="true"
                        v-model="proposal.supervisors[0].internationalPatent"
                      ></b-form-checkbox>
                      <label class="ml-2"
                        ><h6 class="text-primary">
                          ثبت اختراع بین‌المللی
                        </h6></label
                      >
                    </div>
                  </b-form-group>

                  <div v-if="proposal.supervisors[0].internationalPatent">
                    <b-row>
                      <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                        <strong class="text-primary">عنوان اختراع: </strong
                        >{{ proposal.supervisors[0].internationalPatentTitle }}
                      </b-col>
                      <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                        <strong class="text-primary">سال اختراع: </strong
                        >{{ proposal.supervisors[0].internationalPatentYear }}
                      </b-col>
                    </b-row>
                    <b-row class="my-0 py-0">
                      <b-col cols="12">
                        <strong class="text-primary">توضیحات اختراع: </strong
                        >{{
                          proposal.supervisors[0].internationalPatentDescription
                        }}
                      </b-col>
                    </b-row>
                  </div>
                  <br />
                  <b-form-group disabled class="mt-2">
                    <div class="d-flex" dir="rtl">
                      <b-form-checkbox
                        :value="true"
                        v-model="proposal.supervisors[0].researchFestivals"
                      ></b-form-checkbox>
                      <label class="ml-2"
                        ><h6 class="text-primary">
                          اعضای برگزیده جشنواره های پژوهشی
                        </h6></label
                      >
                    </div>
                  </b-form-group>
                  <li v-if="proposal.supervisors[0].researchFestivals">
                    <strong class="text-primary">عنوان جشنواره: </strong>
                    {{ proposal.supervisors[0].researchFestivalsTitle }}
                  </li>
                  <br />
                  <b-form-group class="mt-2" disabled>
                    <div class="d-flex" dir="rtl">
                      <b-form-checkbox
                        :value="true"
                        v-model="proposal.supervisors[0].notSupervisor"
                      ></b-form-checkbox>
                      <label class="ml-2"
                        ><h6 class="text-primary">
                          اگر استاد راهنمای متقاضی نیستید تیک را بزنید
                        </h6></label
                      >
                    </div>
                  </b-form-group>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-5 variant="info">
                <h5 class="mb-0 text-white" style="display: inline-block">
                  مشخصات دوره
                </h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-5"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text class="shadow p-3">
                  <ul>
                    <li>
                      <strong class="text-primary">چکیده دوره: </strong
                      >{{ proposal.abstract }}
                    </li>
                    <li>
                      <strong class="text-primary"
                        >ضرورت اجرای دوره (در جهت دستیابی به اهداف ستاد و یا
                        راهبردها و اقدامات سند توسعه زیست فناوری): </strong
                      >{{ proposal.requestNecessity }}
                    </li>
                    <li>
                      <strong class="text-primary">اهداف کلان دوره:</strong
                      >{{ proposal.majorGoals }}
                    </li>
                    <li>
                      <strong class="text-primary">اهداف خرد دوره:</strong
                      >{{ proposal.minorGoals }}
                    </li>
                    <li>
                      <strong class="text-primary"
                        >مزایای دیگر برای کشور: </strong
                      >{{ proposal.benefitsToCountry }}
                    </li>
                    <li>
                      <strong class="text-primary"
                        >روش شناسی (متدولوژی) و مراحل انجام دوره: </strong
                      >{{ proposal.methodology }}
                    </li>
                    <li v-if="proposal.requestProducts.length > 0">
                      <strong class="text-primary"
                        >دستاوردهای عینی و خروجی‌های ملموس(محصول/ محصولات و یا
                        خدمات) حاصل از اجرای دوره:
                      </strong>
                      <!-- NOTE (t-proposal.requestProducts-2) previous -->
                      <b-table
                        responsive
                        small
                        show-empty
                        head-variant="dark"
                        :items="proposal.requestProducts"
                        :fields="achievmentFields"
                        empty-text="رکوردی برای نمایش وجود ندارد"
                        class="table table-secondary my-3"
                      >
                        <template v-slot:head()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.label }}
                          </div>
                        </template>
                        <template v-slot:cell()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.value }}
                          </div>
                        </template>
                        <template v-slot:cell(index)="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.index + 1 }}
                          </div>
                        </template>
                      </b-table>
                    </li>
                    <li>
                      <strong class="text-primary"
                        >سابقه اجرائی یا دوره‌های مشابه در ایران یا خارج از كشور
                        (با ذكر ماخذ): </strong
                      >{{ proposal.executionHistorySimilar }}
                    </li>
                    <li>
                      <strong class="text-primary"
                        >شركای بین‌المللی در اجرای دوره :
                      </strong>
                      {{ proposal.internationalPartners }}
                    </li>
                    <li>
                      <strong class="text-primary">منابع و ماخذ: </strong
                      >{{ proposal.references }}
                    </li>
                    <li>
                      <strong class="text-primary"
                        >حمایتهای احتمالی قبلی ستاد از دوره:
                      </strong>
                      {{ proposal.postDocLastSupports }}
                    </li>
                  </ul>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-7 variant="light">
                <h5 class="mb-0" style="display: inline-block">
                  زمان‌بندی دوره
                </h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-7"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text class="p-3 shadow">
                  <b class="text-primary">زمان شروع:</b>
                  {{
                    proposal.gantData.length > 0
                      ? moment(
                          new Date(
                            Math.min(
                              ...proposal.gantData.map((x) =>
                                new Date(
                                  moment(x.startDate, "jYYYY/jMM/jDD").format(
                                    "YYYY-MM-DD"
                                  )
                                ).getTime()
                              )
                            )
                          )
                        ).format("jYYYY/jMM/jDD")
                      : ""
                  }}
                  <br />
                  <b class="text-primary">زمان پایان:</b>
                  {{
                    proposal.gantData.length > 0
                      ? moment(
                          new Date(
                            Math.max(
                              ...proposal.gantData.map((x) =>
                                new Date(
                                  moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                    "YYYY-MM-DD"
                                  )
                                ).getTime()
                              )
                            )
                          )
                        ).format("jYYYY/jMM/jDD")
                      : ""
                  }}
                  <br />
                  <b class="text-primary">مدت زمان:</b>
                  {{
                    proposal.gantData.length > 0
                      ? (Math.max(
                          ...proposal.gantData.map((x) =>
                            new Date(
                              moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        ) -
                          Math.min(
                            ...proposal.gantData.map((x) =>
                              new Date(
                                moment(x.startDate, "jYYYY/jMM/jDD").format(
                                  "YYYY-MM-DD"
                                )
                              ).getTime()
                            )
                          )) /
                          3600 /
                          24 /
                          1000 +
                        " روز"
                      : ""
                  }}
                  <br />
                  <br />
                  <div>
                    <sarmadGantt
                      :items="proposal.gantData"
                      :fields="serviceFields"
                    />
                  </div>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-8 variant="dark">
                <h5 class="mb-0" style="display: inline-block">هزینه‌ها</h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-8"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text class="shadow p-3">
                  <div v-if="proposal.personnelCosts.length > 0">
                    <hr />
                    <h5 class="mt-5 mb-3 text-primary">
                      هزینه‌های پرسنلی اعم از مجری و همكاران
                    </h5>

                    <!-- NOTE (t-personnelCost2) previous -->
                    <b-table
                      responsive
                      small
                      show-empty
                      head-variant="dark"
                      :items="proposal.personnelCosts"
                      :fields="PersonnelCostField"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary mb-4"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                      <template v-slot:cell(humanResourceCost)="data">
                        <div>
                          {{
                            (
                              parseInt(data.item.perPersonCost) *
                              parseInt(data.item.cooperationHour)
                            ).toLocaleString()
                          }}
                        </div>
                      </template>
                    </b-table>
                    <!-- {{proposal.personnelCosts.map(x=>x.humanResourceCost).reduce((a,b)=>(parseInt(a)+parseInt(b)))}} -->
                    <p>
                      جمع کل هزینه های پرسنلی:
                      {{
                        proposal.personnelCosts.length == 0
                          ? 0
                          : proposal.personnelCosts
                              .map(
                                (x) =>
                                  parseInt(x.perPersonCost) *
                                  parseInt(x.cooperationHour)
                              )
                              .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                              .toLocaleString()
                      }}
                      تومان
                    </p>
                  </div>

                  <div v-if="proposal.travelExpenses.length > 0">
                    <h5 class="mt-5 mb-3 text-primary">
                      هزینه مسافرت‌های ضروری (اعم از هزینه بلیط، اسكان، غذا، حمل
                      و نقل، حق مأموریت و ...):
                    </h5>

                    <!-- NOTE (t-tripCost2) previous -->
                    <b-table
                      responsive
                      small
                      show-empty
                      head-variant="dark"
                      :items="proposal.travelExpenses"
                      :fields="tripCostField"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary mb-4"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                    </b-table>
                    جمع کل مسافرتهای ضروری:
                    {{
                      proposal.travelExpenses.length == 0
                        ? 0
                        : proposal.travelExpenses
                            .map((x) => x.cost)
                            .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                            .toLocaleString()
                    }}
                    تومان
                  </div>
                  <div v-if="proposal.purchases.length > 0">
                    <h5 class="mt-5 mb-3 text-primary">
                      هزینه دستگاه‌ها، وسایل و مواد مورد نیازكه باید از محل
                      اعتبار طرح خریداری شوند:
                    </h5>

                    <!-- NOTE (t-deviceCost2) previous -->
                    <b-table
                      responsive
                      small
                      show-empty
                      head-variant="dark"
                      :items="proposal.purchases"
                      :fields="deviceCostField"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                      <template v-slot:cell(totalPrice)="data">
                        <div>
                          {{
                            (
                              parseInt(data.item.number) *
                              parseInt(data.item.perPrice)
                            ).toLocaleString()
                          }}
                        </div>
                      </template>
                    </b-table>
                    جمع کل هزینه دستگاه‌ها:
                    {{
                      proposal.purchases.length == 0
                        ? 0
                        : proposal.purchases
                            .map(
                              (x) => parseInt(x.perPrice) * parseInt(x.number)
                            )
                            .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                            .toLocaleString()
                    }}
                    تومان
                    <hr />
                  </div>

                  <div
                    v-if="proposal.participationOrganizationBudget.length > 0"
                  >
                    <h5 class="mt-5 mb-3 text-primary">
                      میزان مشارکت سایر موسسات:
                    </h5>

                    <!-- NOTE (t-orgCost2) previous -->
                    <b-table
                      responsive
                      small
                      show-empty
                      head-variant="dark"
                      :items="proposal.participationOrganizationBudget"
                      :fields="OrgCostField"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                    </b-table>
                    جمع کل مشارکت موسسات:
                    {{
                      proposal.participationOrganizationBudget.length == 0
                        ? 0
                        : proposal.participationOrganizationBudget
                            .map((x) => x.totalPrice)
                            .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                            .toLocaleString()
                    }}
                    تومان
                  </div>
                  <div
                    v-show="
                      proposal.otherCosts
                        .map((x) => x.totalPrice)
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0) > 0
                    "
                  >
                    <h5 class="mt-5 mb-3 text-primary">هزینه‌های دیگر:</h5>

                    <!-- NOTE (t-otherCost2) previous -->
                    <b-table
                      responsive
                      small
                      show-empty
                      head-variant="dark"
                      :items="proposal.otherCosts"
                      :fields="otherCostField"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                    </b-table>
                    <p>
                      جمع کل سایر هزینه‌ها:
                      {{
                        proposal.otherCosts.length == 0
                          ? 0
                          : proposal.otherCosts
                              .map((x) => x.totalPrice)
                              .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                              .toLocaleString()
                      }}
                      تومان
                    </p>
                  </div>
                  <h3>
                    جمع کل هزینه‌ها:
                    {{
                      (tPrice = (
                        (proposal.personnelCosts.length == 0
                          ? 0
                          : proposal.personnelCosts
                              .map(
                                (x) =>
                                  parseInt(x.perPersonCost) *
                                  parseInt(x.cooperationHour)
                              )
                              .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                        (proposal.travelExpenses.length == 0
                          ? 0
                          : proposal.travelExpenses
                              .map((x) => x.cost)
                              .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                        (proposal.purchases.length == 0
                          ? 0
                          : proposal.purchases
                              .map(
                                (x) => parseInt(x.perPrice) * parseInt(x.number)
                              )
                              .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                        (proposal.otherCosts.length == 0
                          ? 0
                          : proposal.otherCosts
                              .map((x) => x.totalPrice)
                              .reduce((a, b) => parseInt(a) + parseInt(b), 0))
                      ).toLocaleString())
                    }}
                    تومان
                  </h3>
                  <hr />
                  <h3>
                    میزان اعتبار مورد نیاز از ستاد زیست فناوری:
                    {{ computedTotalCost.toLocaleString() }}
                    تومان
                  </h3>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-9 variant="dark">
                <h5 class="mb-0" style="display: inline-block">تعهدات</h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-9"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text class="shadow p-3">
                  <b-form-group disabled>
                    <b-form-checkbox
                      :class="proposal.promiseArrays[0] ? 'done' : 'required'"
                      v-model="proposal.promiseArrays[0]"
                    >
                      این طرح در مدت زمان اعلام شده در پروپوزال انجام می‌گردد و
                      مسئولیت تاخیر در انجام طرح بر عهده مجری می‌باشد. مدت زمان:
                      {{
                        proposal.gantData.length > 0
                          ? (Math.max(
                              ...proposal.gantData.map((x) =>
                                new Date(
                                  moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                    "YYYY-MM-DD"
                                  )
                                ).getTime()
                              )
                            ) -
                              Math.min(
                                ...proposal.gantData.map((x) =>
                                  new Date(
                                    moment(x.startDate, "jYYYY/jMM/jDD").format(
                                      "YYYY-MM-DD"
                                    )
                                  ).getTime()
                                )
                              )) /
                              3600 /
                              24 /
                              1000 +
                            " روز"
                          : ""
                      }}
                    </b-form-checkbox>
                    <b-form-checkbox
                      :class="proposal.promiseArrays[1] ? 'done' : 'required'"
                      v-model="proposal.promiseArrays[1]"
                    >
                      این طرح با بودجه اعلام شده در پروپوزال انجام می‌گردد.
                      هزینه انجام:
                      {{
                        (tPrice = (
                          (proposal.personnelCosts.length == 0
                            ? 0
                            : proposal.personnelCosts
                                .map(
                                  (x) =>
                                    parseInt(x.perPersonCost) *
                                    parseInt(x.cooperationHour)
                                )
                                .reduce(
                                  (a, b) => parseInt(a) + parseInt(b),
                                  0
                                )) +
                          (proposal.travelExpenses.length == 0
                            ? 0
                            : proposal.travelExpenses
                                .map((x) => x.cost)
                                .reduce(
                                  (a, b) => parseInt(a) + parseInt(b),
                                  0
                                )) +
                          (proposal.purchases.length == 0
                            ? 0
                            : proposal.purchases
                                .map(
                                  (x) =>
                                    parseInt(x.perPrice) * parseInt(x.number)
                                )
                                .reduce(
                                  (a, b) => parseInt(a) + parseInt(b),
                                  0
                                )) +
                          (proposal.otherCosts.length == 0
                            ? 0
                            : proposal.otherCosts
                                .map((x) => x.totalPrice)
                                .reduce((a, b) => parseInt(a) + parseInt(b), 0))
                        ).toLocaleString())
                      }}
                      تومان
                    </b-form-checkbox>
                    <b-form-checkbox
                      :class="proposal.promiseArrays[2] ? 'done' : 'required'"
                      v-model="proposal.promiseArrays[2]"
                      >کلیه حقوق مادی و معنوی این طرح متعلق به ستاد زیست فناوری
                      می‌باشد.</b-form-checkbox
                    >
                    <b-form-checkbox
                      :class="proposal.promiseArrays[3] ? 'done' : 'required'"
                      v-model="proposal.promiseArrays[3]"
                      >توافق بین دانشگاه و صنعت در خصوص دستاوردهای طرح وجود
                      دارد.</b-form-checkbox
                    >
                    <b-form-checkbox
                      :class="proposal.promiseArrays[4] ? 'done' : 'required'"
                      v-model="proposal.promiseArrays[4]"
                      >نحوه و مسیر تجاری سازی طرح مشخص است و مستندات ارائه شده
                      است.</b-form-checkbox
                    >
                    <b-form-checkbox
                      :class="proposal.promiseArrays[5] ? 'done' : 'required'"
                      v-model="proposal.promiseArrays[5]"
                    >
                      بهره‌بردار نهایی طرح مشخص است و مستندات ارائه شده است. نام
                      بهره‌بردار:
                      {{
                        (proposal.researcherName
                          ? proposal.researcherName
                          : "-") +
                        " " +
                        proposal.researcherLastName
                      }}
                    </b-form-checkbox>
                    <b-form-checkbox
                      :class="proposal.promiseArrays[6] ? 'done' : 'required'"
                      v-model="proposal.promiseArrays[6]"
                      >حداقل 1 مقاله ISI معتبر به عنوان خروجی طرح تعهد
                      می‌شود.</b-form-checkbox
                    >
                    <b-form-checkbox
                      :class="proposal.promiseArrays[7] ? 'done' : 'required'"
                      v-model="proposal.promiseArrays[7]"
                      >تمامی گزارش‌ها پیشرفت در موعد مقرر مطابق با گانت چارت
                      انجام خواهد شد.</b-form-checkbox
                    >
                    <b-form-checkbox
                      :class="proposal.promiseArrays[8] ? 'done' : 'required'"
                      v-model="proposal.promiseArrays[8]"
                      >کلیه گزارش‌ها و خروجی‌ها و دستاوردهای طرح در پایان انجام
                      طرح به ستاد زیست فناوری ارسال و تحویل داده
                      می‌شود.</b-form-checkbox
                    >
                    <b-form-checkbox
                      :class="proposal.promiseArrays[9] ? 'done' : 'required'"
                      v-model="proposal.promiseArrays[9]"
                      >کلیه اصلاحات در مورد مقرر و طی 2 هفته توسط مجری انجام و
                      در سایت بارگذاری می‌گردد.</b-form-checkbox
                    >
                    <b-form-checkbox
                      :class="proposal.promiseArrays[10] ? 'done' : 'required'"
                      v-model="proposal.promiseArrays[10]"
                      >ثبت اطلاعات در سامانه هیچ تعهدی را برای ستاد ایجاد
                      نمی‌کند و به منزله ثبت درخواست متقاضی
                      است.</b-form-checkbox
                    >
                    <b-form-checkbox
                      :class="proposal.promiseArrays[11] ? 'done' : 'required'"
                      v-model="proposal.promiseArrays[11]"
                      >سوابق پژوهشگر با موضوع دوره منطبق است.</b-form-checkbox
                    >
                    <b-form-checkbox
                      :class="proposal.promiseArrays[12] ? 'done' : 'required'"
                      v-model="proposal.promiseArrays[12]"
                      >سوابق استاد راهنما با موضوع دوره منطبق
                      است.</b-form-checkbox
                    >
                    <b-form-checkbox
                      :class="proposal.promiseArrays[13] ? 'done' : 'required'"
                      v-model="proposal.promiseArrays[13]"
                      >کلیه موارد فوق مورد تایید اینجانب
                      {{
                        (proposal.researcherName
                          ? proposal.researcherName
                          : "-") +
                        " " +
                        (proposal.researcherLastName
                          ? proposal.researcherLastName
                          : "")
                      }}
                      به عنوان مجری طرح و همکاران می‌باشد.</b-form-checkbox
                    >
                  </b-form-group>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
        </b-tab>
        <b-tab title="اطلاعات تجاری‌سازی">
          <v-row class="px-4">
            <v-col>
              <h4 class="c-dark mt-2">
                نوع تجاری‌سازی:
                {{
                  proposal.commercializingType == "company"
                    ? "شرکت دانش بنیان"
                    : proposal.commercializingType == "accelerator"
                    ? "شتاب‌دهنده"
                    : "فاقد اطلاعات تجاری‌سازی می‌باشد"
                }}
              </h4>
            </v-col>
            <v-col class="text-left">
              <v-btn
                class="red darken-2 white--text float-end ms-2 btn-radius"
                elevation="0"
                height="41"
                v-if="role == 'admin' && proposal.commercializingType != 'none'"
                @click="removeCommercializationDialog = true"
              >
                <v-icon class="pe-1">mdi-close-box-multiple-outline</v-icon>
                حذف تجاری‌سازی
              </v-btn>
              <v-btn
                class="bc-primary white--text float-end btn-radius"
                elevation="0"
                height="41"
                v-if="role == 'admin'"
                @click="editCommercializationDialog = true"
              >
                <v-icon class="pe-1">mdi-pencil-box-multiple-outline</v-icon>
                ویرایش
              </v-btn>
            </v-col>
          </v-row>
          <b-card-body>
            <b-card-text>
              <div v-if="proposal.commercializingType == 'company'">
                <ul>
                  <div v-if="proposal.companyId != notCompany">
                    <li>
                      <strong class="text-primary">نام شرکت دانش بنیان: </strong
                      >{{ proposal.companyName }}
                    </li>
                    <li>
                      <strong class="text-primary">شماره ثبت شرکت: </strong
                      >{{
                        proposal.companyRegistrationNumber
                          ? proposal.companyRegistrationNumber
                          : "-"
                      }}
                    </li>
                    <li>
                      <strong class="text-primary">شناسه ملی شرکت: </strong
                      >{{
                        proposal.companyNationalId
                          ? proposal.companyNationalId
                          : "-"
                      }}
                    </li>
                  </div>
                  <div v-else>
                    <li>
                      <strong class="text-primary">نام شرکت دانش بنیان: </strong
                      >{{ proposal.otherCompanyName }}
                    </li>
                    <li>
                      <strong class="text-primary">شماره ثبت شرکت: </strong>
                      {{ proposal.otherCompanyRegistrationNumber }}
                    </li>
                    <li>
                      <strong class="text-primary">شناسه ملی شرکت: </strong
                      >{{ proposal.otherCompanyNationalId }}
                    </li>
                  </div>
                  <li>
                    <strong class="text-primary"
                      >معرفی فناوری یا محصولات شرکت:
                    </strong>
                    {{ proposal.companyProducts }}
                  </li>
                  <li>
                    <strong class="text-primary"
                      >آدرس پستی / شماره تماس/ پست الکترونیک شرکت:
                    </strong>
                    {{ proposal.companyContactInfo }}
                  </li>
                </ul>
              </div>
              <ul v-else-if="proposal.commercializingType == 'accelerator'">
                <li>
                  <strong class="text-primary">نام شتاب‌دهنده:</strong>

                  {{ proposal.acceleratorName }}
                </li>
              </ul>
              <div v-else-if="proposal.commercializingType == 'none'">
                <div class="d-flex flex-row mb-2">
                  <b-form-checkbox
                    disabled
                    v-model="proposal.commercializingObligation1"
                    @change="reactivity = !reactivity"
                  ></b-form-checkbox
                  ><span class="ps-2">
                    تایید میکنم با انتخاب این گزینه تا قبل از تایید درخواست توسط
                    یکی از شتاب‌دهنده‌ها یا شرکت‌های مجاز، ستاد توسعه زیست
                    فناوری هیچگونه مسئولیتی در قبال درخواست من نخواهد داشت.
                  </span>
                </div>
                <div class="d-flex flex-row mb-2">
                  <b-form-checkbox
                    disabled
                    v-model="proposal.commercializingObligation2"
                    @change="reactivity = !reactivity"
                  ></b-form-checkbox>
                  <span class="ps-2">
                    تایید میکنم با انتخاب این گزینه، کلیه اطلاعات شخصی و علمی
                    این درخواست، در اختیار شتاب‌دهنده‌ها و شرکت‌های مجاز قرار
                    خواهد گرفت تا بتوانند با بررسی اطلاعات، درخواست بنده را
                    بررسی و تایید کنند.
                  </span>
                </div>
              </div>
              <div class="mt-5">
                <h5 class="mb-5">
                  ملاحظات مربوط به همکاری طرفین، بازار و عایدی دوره
                </h5>
                <ul>
                  <li>
                    <strong class="text-primary"
                      >نحوه تعامل با دانشگاه یا مراکز و ملاحظات مربوط به حق
                      <strong class="text-primary">مالکیت: </strong></strong
                    >
                    {{ proposal.interactUniversityCenters }}
                  </li>
                  <li class="mt-3">
                    <strong class="text-primary">معرفی بازار هدف: </strong
                    >{{ proposal.targetMarket }}
                  </li>
                  <li class="mt-3">
                    <strong class="text-primary"
                      >پیش بینی میزان فروش محصول در سه سال اول:
                    </strong>
                    {{ proposal.productSalesForecast }}
                  </li>
                  <li class="mt-3">
                    <strong class="text-primary"
                      >میزان اشتغال زایی دوره: </strong
                    >{{ proposal.employment }}
                  </li>
                  <li class="mt-3">
                    <strong class="text-primary"
                      >برآورد مدت زمان همکاری: </strong
                    >{{ proposal.durationCooperation }}
                  </li>
                  <li class="mt-3">
                    <strong class="text-primary"
                      >برآورد میزان تولید و عایدی دوره:
                    </strong>
                    {{ proposal.estimationProductionProjectRevenue }}
                  </li>
                  <li class="mt-3">
                    <strong class="text-primary"
                      >محصولات رقیب و میزان رقابت پذیری(مقایسه قیمت) (در صورت
                      وجود):
                    </strong>
                    {{ proposal.competitiveProductsLevelCompetitiveness }}
                  </li>
                  <li class="mt-3">
                    <strong class="text-primary"
                      >مزیت محصول نسبت به موارد مشابه و موجود:
                    </strong>
                    {{ proposal.productAdvantages }}
                  </li>
                </ul>
              </div>
            </b-card-text>
          </b-card-body>
          <v-dialog v-model="editCommercializationDialog" width="700">
            <v-card>
              <v-card-title>
                <h4 class="primary--text my-1">ویرایش اطلاعات تجاری‌سازی</h4>
              </v-card-title>
              <hr class="mt-0" />
              <v-card-text class="pb-0">
                <div v-if="proposal.commercializingType == 'company'">
                  <b class="h5">نام شرکت دانش بنیان فعلی: </b>
                  <span class="h5">{{
                    proposal.companyId != notCompany
                      ? proposal.companyName
                      : proposal.otherCompanyName
                  }}</span>
                </div>
                <div v-if="proposal.commercializingType == 'accelerator'">
                  <b>نام شتاب‌دهنده فعلی: </b>
                  <span>{{ proposal.acceleratorName }}</span>
                </div>
                <div v-if="proposal.commercializingType == 'none'">
                  <b class="h5">حمایت فعلی فاقد تجاری‌سازی است.</b>
                </div>
                <div class="mt-6">
                  <v-row class="pb-1">
                    <v-col class="pt-6">
                      <span class="fs-medium">نام شتاب‌دهنده مورد نظر را انتخاب کنید:</span>
                    </v-col>
                    <v-col class="text-left">
                      <div class="text-left">
                        <v-btn @click="viewList()" class="primary white--text"
                          ><span class="fs-medium"
                            ><v-icon class="me-1">mdi-table-of-contents</v-icon
                            >مشاهده لیست شتاب‌دهنده‌ها</span
                          ></v-btn
                        >
                      </div>
                    </v-col>
                  </v-row>
                  <v-autocomplete
                    v-model="newAcceleratorId"
                    :items="accelerators"
                    outlined
                    dense
                    class="mt-3"
                    item-value="id"
                    item-text="text"
                  >
                  </v-autocomplete>
                </div>
              </v-card-text>
              <v-card-actions class="pb-4">
                <v-spacer></v-spacer>
                <v-btn
                  color="red darken-1 white--text"
                  @click="editCommercializationDialog = false"
                  elevation="0"
                  width="100"
                >
                  لغو
                </v-btn>
                <v-btn
                  color="primary darken-1"
                  @click="
                    editCommercializationDialog = false;
                    editCommercialization();
                  "
                  :disabled="!newAcceleratorId"
                  elevation="0"
                  width="100"
                >
                  ثبت
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="removeCommercializationDialog" width="700">
            <v-card>
              <v-card-title>
                <h4 class="primary--text my-1">حذف اطلاعات تجاری‌سازی</h4>
              </v-card-title>
              <hr class="mt-0" />
              <v-card-text class="pb-0">
                <div>
                  <p class="mb-2">توضیحات (درصورت نیاز)</p>
                  <v-textarea
                    v-model="proposal.removeDescription"
                    outlined
                    rows="8"
                  ></v-textarea>
                </div>
              </v-card-text>
              <v-card-actions class="pb-4">
                <v-spacer></v-spacer>
                <v-btn
                  color="red darken-1 white--text"
                  @click="removeCommercializationDialog = false"
                  elevation="0"
                  width="100"
                >
                  لغو
                </v-btn>
                <v-btn
                  color="primary darken-1"
                  @click="removeCommercialization()"
                  :loading="removeLoading"
                  elevation="0"
                  width="100"
                >
                  حذف
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </b-tab>
        <b-tab title="فایل های تکمیلی">
          <h6>
            <b-input-group size="md">
              <b-form-input
                trim
                v-model="fileFilter"
                type="search"
                id="filterInput"
                placeholder="جستجو"
              ></b-form-input>
              <b-input-group-append>
                <!-- NOTE (b-delete) to delete the text of the search bar -->
                <b-button
                  :disabled="!fileFilter"
                  @click="fileFilter = ''"
                  variant="danger"
                  >حذف</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </h6>

          <!-- NOTE (t-files) to show the proposal files -->
          <b-table
            responsive
            show-empty
            head-variant="dark"
            :fields="fileFields"
            :items="proposal.uploadedFiles.filter((x) => x && x.url != '')"
            :filter="fileFilter"
            empty-text="فایلی برای نمایش وجود ندارد"
            empty-filtered-text="فایلی برای نمایش وجود ندارد"
            striped
            :busy="fileBusy"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(url)="data">
              <div style="text-align: center; vertical-align: middle">
                <!-- NOTE (<a>) to download the uploaded files by opening a new page -->
                <a
                  v-if="data.value"
                  class="btn btn-success white--text"
                  :href="data.value"
                  target="_blank"
                  >دریافت فایل</a
                >
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + 1 }}
              </div>
            </template>
            <div slot="table-busy" class="text-center text-danger my-2">
              <strong class="text-primary">در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
        </b-tab>
        <b-tab v-if="role == 'admin' || role == 'manager'" title="داوری">
          <!-- NOTE (t-review) to show the reviews list -->
          <b-table
            responsive
            small
            show-empty
            head-variant="dark"
            :items="reviews"
            :fields="judgementFields"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary my-3"
          >
            <template v-slot:cell(referee)="data">
              <span v-if="data.item.isAccelerator">{{
                data.item.accelerator + " (شتاب‌دهنده)"
              }}</span>

              <span v-else>{{ data.value }}</span>
            </template>
            <template v-slot:cell(decision)="data">
              <span
                v-if="data.item.isAccelerator && data.item.status == 'Done'"
              >
                <span v-if="data.item.isApproved">تایید حمایت</span>
                <span v-else>عدم تایید حمایت</span>
              </span>

              <span v-else>{{ data.value }}</span>
            </template>
            <template v-slot:cell(description)="row">
              <b-button
                size="sm"
                @click="row.toggleDetails"
                class="mr-2"
                :variant="row.detailsShowing ? 'danger' : 'success'"
                v-if="
                  (!row.item.isAccelerator && row.item.status == 'Done') ||
                  (row.item.isAccelerator &&
                    row.item.status == 'Done' &&
                    row.item.isApproved)
                "
                >{{ row.detailsShowing ? "بستن" : "نمایش" }} داوری</b-button
              >&nbsp;
              <span
                v-if="
                  row.item.isAccelerator &&
                  row.item.status == 'Done' &&
                  !row.item.isApproved
                "
                >-</span
              >
              <!-- NOTE (b-expire) to expiration of the refree -->
              <b-button
                size="sm"
                @click="removeJudge(row)"
                variant="warning"
                class="mr-2"
                v-show="
                  row.item.status != 'Expired' &&
                  row.item.status != 'Done' &&
                  role != 'manager'
                "
                >انقضا داوری</b-button
              >
            </template>
            <template v-slot:row-details="row">
              <div v-if="row.item.isAccelerator" class="text-right py-2">
                <b-card class="mb-0">
                  <v-row>
                    <v-col
                      class="d-flex flex-row justify-space-between pe-8 py-2"
                    >
                      <span class="text-primary font-weight-bold"
                        >حداقل حمایت مورد نظر:</span
                      >
                      <span
                        >{{
                          Number(row.item.minSupport).toLocaleString()
                        }}
                        تومان</span
                      >
                    </v-col>
                    <v-divider vertical></v-divider>
                    <v-col
                      class="d-flex flex-row justify-space-between ps-8 py-2"
                    >
                      <span class="text-primary font-weight-bold"
                        >حداکثر حمایت مورد نظر:</span
                      >
                      <span
                        >{{
                          Number(row.item.maxSupport).toLocaleString()
                        }}
                        تومان</span
                      >
                    </v-col>
                  </v-row>
                </b-card>
              </div>
              <Review
                v-else
                :disabled="true"
                :scoresData="row.item.scores"
                :refereeIdea="row.item.description"
                :refereeDecision="row.item.decisionEn"
              />
            </template>
            <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>
            <template v-slot:cell(status)="data">
              {{ statusDictionary.find((x) => x.en == data.value).fa }}
            </template>
          </b-table>
        </b-tab>
        <b-tab v-if="role == 'admin' || role == 'manager'" title="تاریخچه">
          <!-- :text-variant="'white'" -->
          <b-card
            :bg-variant="computedVariant(index)"
            v-for="(p, index) in computedJournals"
            :key="index"
            style="max-width: 80%"
            class="mb-3 border-0 shadow"
          >
            <template slot="header">
              <b-row>
                <b-col>
                  <h5>{{ p.name }}</h5>
                </b-col>
                <b-col>
                  <div style="float: left">
                    <h5>{{ p.date }}</h5>
                  </div>
                </b-col>
              </b-row>
            </template>

            <h6>{{ p.message }}</h6>
          </b-card>
        </b-tab>
        <b-tab v-if="role == 'admin'" title="مدیریت وضعیت">
          <b-form-group id="fieldset-1" description label="وضعیت طرح">
            <b-form-group>
              <Select2
                v-model="selectedSituation"
                :options="situationsOptions"
                :settings="{ width: '75%' }"
              ></Select2>

              <!-- <b-form-select v-model="selectedStatus" :options="statusOptions"></b-form-select> -->
            </b-form-group>
            <div v-if="selectedSituation == 8">
              <b-row>
                <i
                  class="fa fa-exclamation-triangle fa-2x text-warning ml-3"
                  aria-hidden="true"
                ></i>
                <p class="mt-2 ml-2 text-danger">
                  تذکر: لطفا توجه داشته باشد که متن نگارش شده توسط شما بدون
                  تغییر در اختیار کاربر قرار خواهد گرفت
                </p>
              </b-row>
            </div>
            <div v-if="selectedSituation == 3">
              <b-form-group label="داوران">
                <v-select
                  multiple
                  :reduce="(x) => x.code"
                  :options="reviewersOptions"
                  style="direction: rtl"
                  v-model="reviewers"
                >
                  <template v-slot:option="option">
                    <div class="text-right">
                      {{ option.label
                      }}<b-badge class="m-1 p-1" variant="info"
                        >کل {{ option.all }}</b-badge
                      ><b-badge class="m-1 p-1" variant="success"
                        >انجام شده {{ option.dones }}</b-badge
                      ><b-badge class="m-1 p-1" variant="danger"
                        >لغو شده {{ option.expireds }}</b-badge
                      ><b-badge class="m-1 p-1" variant="warning"
                        >در جریان {{ option.ongoings }}</b-badge
                      >
                    </div>
                  </template>
                </v-select>
              </b-form-group>
              <div v-if="reviewers.length">
                <div class="mb-2">داوران انتخاب شده</div>
                <div
                  class="selected-referees"
                  v-for="(item, index) in computedSelectedReferees"
                  :key="index"
                >
                  <v-card>
                    <v-card-title>{{ item.label }}</v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col>داوری‌های دعوت شده: {{ item.all }}</v-col>
                        <v-col>داوری‌های انجام شده: {{ item.dones }}</v-col>
                      </v-row>
                      <v-row>
                        <v-col>داوری‌های در جریان: {{ item.ongoings }}</v-col>
                        <v-col>داوری‌های لغو شده: {{ item.expireds }}</v-col>
                      </v-row>
                      <v-row v-if="item.tags.length != 0">
                        <v-col class="selected-referees__tags">
                          <h6>برچسب‌های داور</h6>
                          <b-badge
                            class="tag"
                            v-for="(tag, index2) in item.tags"
                            :key="index2"
                            variant="primary"
                            >{{ tag }}</b-badge
                          >
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </div>
              </div>
            </div>
            <b-form-group
              label="دلایل رد درخواست"
              v-else-if="selectedSituation == 9"
            >
              <v-select
                multiple
                :reduce="(x) => x.code"
                :options="rejectOptions"
                v-model="proposal.rejectionIds"
              >
              </v-select>
            </b-form-group>
            <b-form-group v-else-if="selectedStatus == 3"></b-form-group>
            <div
              v-if="
                selectedSituation == 3 &&
                proposal.commercializingType == 'accelerator'
              "
              class="d-flex flex-row pt-2"
            >
              <b-form-checkbox
                style="margin-right: -8px"
                v-model="proposal.isAccelerator"
              >
              </b-form-checkbox>
              <p class="ml-2">
                امکان داوری حمایت برای شتاب‌دهنده نیز وجود دارد.
              </p>
            </div>
            <hr
              v-if="
                selectedSituation == 3 &&
                proposal.commercializingType == 'accelerator'
              "
              class="mt-2"
            />
            <b-form-group
              v-if="selectedSituation == 3"
              label="یادداشت برای داور:"
            >
              <b-form-textarea v-model="proposal.adminToReferee">
              </b-form-textarea>
            </b-form-group>
            <div v-if="selectedSituation == 7">
              <div>
                <b-row>
                  <b-col>
                    <h3 class="m-auto ml-4">وضعیت قرارداد</h3>
                    <br />

                    <b-form-radio-group v-model="contract">
                      <div class="d-flex" dir="rtl">
                        <b-form-radio :value="true"></b-form-radio>
                        <label class="ml-2 mt-1"
                          ><h6>شامل قرارداد می‌شود</h6></label
                        >
                      </div>
                      <div class="d-flex" dir="rtl">
                        <b-form-radio :value="false"></b-form-radio>
                        <label class="ml-2 mt-1"
                          ><h6>شامل قرارداد نمی‌شود</h6></label
                        >
                      </div>
                    </b-form-radio-group>
                  </b-col>
                  <b-col>
                    <h3 class="m-auto ml-4">ناظر</h3>
                    <br />

                    <b-form-radio-group v-model="haveReferee">
                      <div class="d-flex" dir="rtl">
                        <b-form-radio :value="true"></b-form-radio>
                        <label class="ml-2 mt-1"><h6>ناظر نیاز دارد</h6></label>
                      </div>
                      <div class="d-flex" dir="rtl">
                        <b-form-radio :value="false"></b-form-radio>
                        <label class="ml-2 mt-1"
                          ><h6>ناظر نیاز ندارد</h6></label
                        >
                      </div>
                    </b-form-radio-group>
                  </b-col>
                </b-row>
                <div v-if="haveReferee">
                  <b-form-group label="ناظر مربوطه">
                    <v-select
                      :reduce="(x) => x.code"
                      :options="reviewersOptions"
                      style="direction: rtl"
                      v-model="selectedReferee"
                    >
                      <template v-slot:option="option">
                        <div class="text-right">
                          {{ option.label
                          }}<b-badge class="m-1 p-1" variant="info"
                            >کل {{ option.all }}</b-badge
                          ><b-badge class="m-1 p-1" variant="success"
                            >انجام شده {{ option.dones }}</b-badge
                          ><b-badge class="m-1 p-1" variant="danger"
                            >لغو شده {{ option.expireds }}</b-badge
                          ><b-badge class="m-1 p-1" variant="warning"
                            >در جریان {{ option.ongoings }}</b-badge
                          >
                        </div>
                      </template>
                    </v-select>
                  </b-form-group>
                  <div v-if="selectedReferee.length">
                    <div class="mb-2">ناظر انتخاب شده</div>
                    <div
                      class="selected-referees"
                      v-for="(item, index) in computedSelectedReferees2"
                      :key="index"
                    >
                      <v-card>
                        <v-card-title>{{ item.label }}</v-card-title>
                        <v-card-text>
                          <v-row>
                            <v-col>داوری‌های دعوت شده: {{ item.all }}</v-col>
                            <v-col>داوری‌های انجام شده: {{ item.dones }}</v-col>
                          </v-row>
                          <v-row>
                            <v-col
                              >داوری‌های در جریان: {{ item.ongoings }}</v-col
                            >
                            <v-col
                              >داوری‌های لغو شده: {{ item.expireds }}</v-col
                            >
                          </v-row>
                          <v-row v-if="item.tags.length != 0">
                            <v-col class="selected-referees__tags">
                              <h6>برچسب‌های داور</h6>
                              <b-badge
                                class="tag"
                                v-for="(tag, index2) in item.tags"
                                :key="index2"
                                variant="primary"
                                >{{ tag }}</b-badge
                              >
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </div>
                  </div>
                </div>

                <div
                  v-if="proposal.commercializingType == 'accelerator'"
                  class="d-flex flex-row pt-4"
                >
                  <b-form-checkbox
                    style="margin-right: -8px"
                    v-model="isAccelerator"
                  >
                  </b-form-checkbox>
                  <p class="ml-2">گزارش‌ها نیاز به تایید شتاب‌دهنده دارند.</p>
                </div>

                <b-form-group label="یادداشت برای پژوهشگر:" class="mt-4">
                  <b-form-textarea
                    trim
                    id="textarea"
                    aria-describedby="adminMessage"
                    v-model="adminMessage"
                    width="75%"
                    rows="8"
                    max-rows="10"
                  ></b-form-textarea>
                </b-form-group>
              </div>

              <div>
                <h4 class="text-center text-dark">افزودن گزارش</h4>

                <b-button
                  variant="success"
                  class="mb-3 ml-1"
                  @click="addReport()"
                  ><strong>افزودن +</strong></b-button
                >
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="light"
                  :items="reportItems"
                  :fields="reportFields"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>

                  <template v-slot:cell(name)="data">
                    <b-form-input
                      trim
                      v-model="data.item.name"
                      type="text"
                    ></b-form-input>
                  </template>
                  <template v-slot:cell(date)="data">
                    <datePicker
                      color="#7b1fa2"
                      v-model="data.item.date"
                    ></datePicker>
                  </template>
                  <template v-slot:cell(operation)="data">
                    <b-button
                      variant="danger"
                      class="mr-2"
                      @click="removeReport(data.index)"
                      >x</b-button
                    >
                  </template>
                </b-table>
                <hr />
                <h4 class="text-center text-dark">افزودن فایل</h4>

                <b-button variant="success" class="mb-3 ml-1" @click="addFile()"
                  ><strong>افزودن +</strong></b-button
                >
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="light"
                  :items="fileItems"
                  :fields="filesFields"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>

                  <template v-slot:cell(name)="data">
                    <b-form-input
                      trim
                      v-model="data.item.name"
                      type="text"
                    ></b-form-input>
                  </template>
                  <template v-slot:cell(date)="data">
                    <datePicker
                      color="#7b1fa2"
                      v-model="data.item.date"
                    ></datePicker>
                  </template>
                  <template v-slot:cell(operation)="data">
                    <b-button
                      variant="danger"
                      class="mr-2"
                      @click="removeFile(data.index)"
                      >x</b-button
                    >
                  </template>
                </b-table>
              </div>
            </div>
            <b-form-group label="یادداشت" class="mt-4">
              <b-form-textarea
                trim
                id="textarea"
                v-model="proposal.description"
                :state="
                  selectedSituation == 8
                    ? proposal.description
                      ? null
                      : false
                    : null
                "
                width="75%"
                placeholder="نظرات خود را اینجا وارد نمایید"
                rows="8"
                max-rows="10"
              ></b-form-textarea>

              <b-form-invalid-feedback
                id="comments"
                :state="
                  selectedStatus == 'نیاز به تکمیل / اصلاح'
                    ? proposal.description
                      ? null
                      : false
                    : null
                "
                >با نوشتن نظر خود میتوانید پژوهشگر را در انجام اصلاحات مورد نیاز
                راهنمایی کنید</b-form-invalid-feedback
              >
            </b-form-group>
            <b-form-group>
              <!-- NOTE (b-editProposal) to submit the proposal changes -->
              <b-button
                :disabled="disableEditProposal"
                @click="
                  editProposal(
                    situationsOptions.filter(
                      (x) => x.id == selectedSituation
                    )[0].eng
                  )
                "
                >ثبت</b-button
              >
            </b-form-group>
          </b-form-group>
        </b-tab>
        <b-tab v-if="proposal.isArchive" title="نسخه‌های پیشین">
          <b-tabs vertical pills fill>
            <b-tab v-for="(old, index) in proposal.archives" :key="index">
              <template slot="title">
                <div class="d-flex flex-column align-items-center">
                  {{ "نسخه" + " " + Number(proposal.archives.length - index) }}
                  <p class="mb-0">({{ old.registerDate }})</p>
                </div>
              </template>
              <b-tabs pills>
                <b-tab title="چکیده طرح" active lazy>
                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button block v-b-toggle.accordion-1 variant="dark">
                        <h5 class="mb-0">عنوان و حمایت‌های پیشین&nbsp;</h5>
                      </b-button>
                    </b-card-header>
                    <b-collapse
                      id="accordion-1"
                      accordion="my-accordion"
                      role="tabpanel"
                      visible
                    >
                      <b-card-body>
                        <b-card-text>
                          <ul>
                            <li>
                              <strong class="text-primary"
                                >عنوان به زبان فارسی: </strong
                              >{{ old.faSubject }}
                            </li>

                            <li>
                              <strong class="text-primary"
                                >آیا این طرح از حمایت‌های قبلی ستاد یا سایر
                                نهادها استفاده کرده است؟
                              </strong>
                              <b-form-radio-group
                                v-model="old.initialIsSupported"
                                disabled
                              >
                                <b-form-radio :value="true">بله</b-form-radio>
                                <b-form-radio :value="false">خیر</b-form-radio>
                              </b-form-radio-group>
                            </li>

                            <li v-if="old.initialIsSupported">
                              <strong class="text-primary">حمایت ها: </strong
                              >{{
                                old.initialSupportedType
                                  ? options.filter(
                                      (x) => x.value == old.initialSupportedType
                                    )[0].text
                                  : ""
                              }}
                            </li>
                            <li v-if="old.initialSupportedType == 'other'">
                              <strong class="text-primary"
                                >عنوان حمایت دریافتی: </strong
                              >{{ old.initialOtherSupport }}
                            </li>
                            <li v-if="old.initialIsSupported">
                              <strong class="text-primary"
                                >توضیحات حمایت دریافتی: </strong
                              >{{ old.initialSupportDescription }}
                            </li>
                          </ul>
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="mb-1">
                    <b-card-header
                      header-tag="header"
                      class="p-1 border-0"
                      role="tab"
                    >
                      <b-button block v-b-toggle.accordion-2 variant="light">
                        <h5 class="mb-0" style="display: inline-block">
                          اطلاعات اصلی دوره‌&nbsp;
                        </h5>
                      </b-button>
                    </b-card-header>
                    <b-collapse
                      id="accordion-2"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text class="shadow p-3">
                          <ul>
                            <li>
                              <strong class="text-primary"
                                >عنوان به زبان فارسی:
                              </strong>
                              {{ old.faSubject }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >عنوان به زبان انگلیسی:
                              </strong>
                              {{ old.enSubject }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >دانشگاه محل اجرای دوره:
                              </strong>
                              {{
                                old.universityId
                                  ? universities.filter(
                                      (x) => x.id == old.universityId
                                    )[0]
                                    ? universities.filter(
                                        (x) => x.id == old.universityId
                                      )[0].text
                                    : "-"
                                  : "-"
                              }}
                            </li>
                            <li v-if="old.universityId == notUniversity">
                              <strong class="text-primary"
                                >نام دانشگاه:
                              </strong>
                              {{ old.otherUniversity }}
                            </li>
                            <li v-if="old.mehvarId != notMehvar">
                              <strong class="text-primary">محور دوره: </strong>
                              {{
                                old.mehvarId
                                  ? mehvars.filter(
                                      (x) => x.id == old.mehvarId
                                    )[0]
                                    ? mehvars.filter(
                                        (x) => x.id == old.mehvarId
                                      )[0].text
                                    : ""
                                  : ""
                              }}
                            </li>
                            <li v-if="old.mehvarId == notMehvar">
                              <strong class="text-primary">محور دوره:</strong>
                              سایر محورها
                            </li>
                            <li v-if="old.mehvarId == notMehvar">
                              <strong class="text-primary">نام محور: </strong
                              >{{ old.otherMehvars }}
                            </li>
                            <li>
                              <strong class="text-primary">ماهیت دوره: </strong>
                              <b-form-group disabled>
                                <b-form-checkbox v-model="old.typeStudy"
                                  >مطالعاتی</b-form-checkbox
                                >
                                <b-form-checkbox
                                  v-model="old.typeSystemicDevelopmental"
                                  >سیستمی و توسعه‌ای</b-form-checkbox
                                >
                                <b-form-checkbox v-model="old.typePractical"
                                  >کاربردی</b-form-checkbox
                                >
                              </b-form-group>
                            </li>
                            <li>
                              <strong class="text-primary">حوزه دوره: </strong>
                              <b-form-group disabled>
                                <b-form-checkbox v-model="old.zoneMedicine"
                                  >پزشکی</b-form-checkbox
                                >
                                <b-form-checkbox v-model="old.zoneAgriculture"
                                  >کشاورزی</b-form-checkbox
                                >
                                <b-form-checkbox v-model="old.zoneEnvironment"
                                  >محیط زیست</b-form-checkbox
                                >
                                <b-form-checkbox v-model="old.zoneIndustrial"
                                  >صنعتی</b-form-checkbox
                                >
                                <b-form-checkbox v-model="old.zoneBioComputing"
                                  >رایانش زیستی</b-form-checkbox
                                >
                                <b-form-checkbox v-model="old.zoneOther"
                                  >سایر</b-form-checkbox
                                >
                              </b-form-group>
                            </li>
                          </ul>
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button block v-b-toggle.accordion-3 variant="light">
                        <h5 class="mb-0" style="display: inline-block">
                          اطلاعات پژوهشگر
                        </h5>
                      </b-button>
                    </b-card-header>
                    <b-collapse
                      id="accordion-3"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text class="shadow p-3">
                          <ul>
                            <li>
                              <strong class="text-primary">نام: </strong
                              >{{ old.researcherName }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >نام خانوادگی: </strong
                              >{{ old.researcherLastName }}
                            </li>
                            <li>
                              <strong class="text-primary">کدملی:</strong
                              >{{ old.researcherNatCode }}
                            </li>
                            <li>
                              <strong class="text-primary">تلفن همراه: </strong
                              >{{ old.researcherMobile }}
                            </li>
                            <li>
                              <strong class="text-primary">دورنگار: </strong
                              >{{ old.researcherFax }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >پست الکترونیکی: </strong
                              >{{ old.researcherEmail }}
                            </li>
                            <li>
                              <strong class="text-primary">استان: </strong
                              >{{ old.researcherState }}
                            </li>
                            <li>
                              <strong class="text-primary">شهر: </strong
                              >{{ old.researcherCity }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >دانشگاه محل تحصیل: </strong
                              >{{
                                universities.filter(
                                  (x) => x.id == old.researcherUniversityId
                                ).length
                                  ? universities.filter(
                                      (x) => x.id == old.researcherUniversityId
                                    )[0]
                                    ? universities.filter(
                                        (x) =>
                                          x.id == old.researcherUniversityId
                                      )[0].text
                                    : "---"
                                  : "---"
                              }}
                            </li>
                            <li
                              v-if="old.researcherUniversityId == notUniversity"
                            >
                              <strong class="text-primary">نام دانشگاه: </strong
                              >{{ old.researcherUniversityOther }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >رشته تحصیلی مقطع دکتری: </strong
                              >{{ old.researcherPhDField }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >عنوان رساله دکتری: </strong
                              >{{ old.researcherPhDThesisSubject }}
                            </li>
                            <li>
                              <strong class="text-primary">تاریخ دفاع: </strong
                              >{{ old.researcherPhDThesisDefenceDate }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >تاریخ دریافت مدرک دکتری: </strong
                              >{{ old.researcherPhDCertificateDate }}
                            </li>
                            <br />
                            <b-form-group disabled>
                              <div class="d-flex" dir="rtl">
                                <b-form-checkbox
                                  :value="true"
                                  v-model="old.researcherArticle"
                                ></b-form-checkbox>
                                <label class="ml-2"
                                  ><h6 class="text-primary">
                                    مشخصات ۳ مقاله ISI با IF بالاتر از ۱ (در
                                    ۳‌سال اخیر)
                                  </h6></label
                                >
                              </div>
                            </b-form-group>
                            <div v-if="old.researcherArticle">
                              <li>
                                <strong class="text-primary"
                                  >شناسه دیجیتالی مقاله (اول):
                                </strong>
                                {{ old.researcherDoi1 }}
                              </li>

                              <br />
                              <li>
                                <strong class="text-primary"
                                  >شناسه دیجیتالی مقاله (دوم):
                                </strong>
                                {{ old.researcherDoi2 }}
                              </li>

                              <br />
                              <li>
                                <strong class="text-primary"
                                  >شناسه دیجیتالی مقاله (سوم):
                                </strong>
                                {{ old.researcherDoi3 }}
                              </li>
                            </div>
                            <br />
                            <b-form-group disabled>
                              <div class="d-flex" dir="rtl">
                                <b-form-checkbox
                                  :value="true"
                                  v-model="old.researcherInternationalPatent"
                                ></b-form-checkbox>
                                <label class="ml-2"
                                  ><h6 class="text-primary">
                                    ثبت اختراع بین‌المللی
                                  </h6></label
                                >
                              </div>
                            </b-form-group>

                            <div v-if="old.researcherInternationalPatent">
                              <b-row>
                                <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                                  <strong class="text-primary"
                                    >عنوان اختراع:
                                  </strong>
                                  {{ old.researcherInternationalPatentTitle }}
                                </b-col>
                                <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                                  <strong class="text-primary"
                                    >سال اختراع:
                                  </strong>
                                  {{ old.researcherInternationalPatentYear }}
                                </b-col>
                              </b-row>
                              <b-row class="my-0 py-0">
                                <b-col cols="12">
                                  <strong class="text-primary"
                                    >توضیحات اختراع:
                                  </strong>
                                  {{
                                    old.researcherInternationalPatentDescription
                                  }}
                                </b-col>
                              </b-row>
                            </div>
                          </ul>
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button block v-b-toggle.accordion-4 variant="warning">
                        <h5 class="mb-0" style="display: inline-block">
                          اطلاعات مسئول دوره پسا دکتری
                        </h5>
                      </b-button>
                    </b-card-header>
                    <b-collapse
                      id="accordion-4"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text
                          class="shadow p-3"
                          v-if="old.supervisors.length"
                        >
                          <ul>
                            <li>
                              <strong class="text-primary">نام: </strong
                              >{{ old.supervisors[0].name }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >نام خانوادگی: </strong
                              >{{ old.supervisors[0].lastName }}
                            </li>
                            <li>
                              <strong class="text-primary">کدملی:</strong
                              >{{ old.supervisors[0].natCode }}
                            </li>
                            <li>
                              <strong class="text-primary">تلفن همراه: </strong
                              >{{ old.supervisors[0].mobile }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >پست الکترونیکی: </strong
                              >{{ old.supervisors[0].email }}
                            </li>
                            <li>
                              <strong class="text-primary">سمت: </strong
                              >{{ old.supervisors[0].position }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >دانشگاه محل تحصیل:
                              </strong>
                              {{
                                universities.filter(
                                  (x) => x.id == old.supervisors[0].universityId
                                ).length
                                  ? universities.filter(
                                      (x) =>
                                        x.id == old.supervisors[0].universityId
                                    )[0]
                                    ? universities.filter(
                                        (x) =>
                                          x.id ==
                                          old.supervisors[0].universityId
                                      )[0].text
                                    : "---"
                                  : "---"
                              }}
                            </li>
                            <li
                              v-if="
                                old.supervisors[0].universityId == notUniversity
                              "
                            >
                              <strong class="text-primary">نام دانشگاه: </strong
                              >{{ old.supervisors[0].universityOther }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >دانشگاه محل اشتغال:
                              </strong>
                              {{
                                old.supervisors[0].universityJobId
                                  ? universities.filter(
                                      (x) =>
                                        x.id ==
                                        old.supervisors[0].universityJobId
                                    )[0]
                                    ? universities.filter(
                                        (x) =>
                                          x.id ==
                                          old.supervisors[0].universityJobId
                                      )[0].text
                                    : "-"
                                  : "-"
                              }}
                            </li>
                            <li
                              v-if="
                                old.supervisors[0].universityJobId ==
                                notUniversity
                              "
                            >
                              <strong class="text-primary">نام دانشگاه: </strong
                              >{{ old.supervisors[0].universityJobOther }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >نوع هیئت علمی:
                              </strong>
                              {{ old.supervisors[0].scienceCommitteeType }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >آخرین مدرک تحصیلی:
                              </strong>
                              {{ old.supervisors[0].lastDegree }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >عنوان رساله دکتری:
                              </strong>
                              {{ old.supervisors[0].phdThesisSubject }}
                            </li>
                            <li>
                              <strong class="text-primary">مرتبه علمی: </strong
                              >{{ old.supervisors[0].academicRank }}
                            </li>
                          </ul>
                          <b-form-group disabled>
                            <div class="d-flex" dir="rtl">
                              <b-form-checkbox
                                :value="true"
                                v-model="old.supervisors[0].article"
                              ></b-form-checkbox>
                              <label class="ml-2"
                                ><h6 class="text-primary">
                                  مشخصات ۵ مقاله ISI با IF بالاتر از ۱ (در ۳‌سال
                                  اخیر)
                                </h6></label
                              >
                            </div>
                          </b-form-group>
                          <div v-if="old.supervisors[0].article">
                            <li>
                              <strong class="text-primary"
                                >شناسه دیجیتالی مقاله (اول):
                              </strong>
                              {{ old.supervisors[0].doi1 }}
                            </li>

                            <br />
                            <li>
                              <strong class="text-primary"
                                >شناسه دیجیتالی مقاله (دوم):
                              </strong>
                              {{ old.supervisors[0].doi2 }}
                            </li>

                            <br />
                            <li>
                              <strong class="text-primary"
                                >شناسه دیجیتالی مقاله (سوم):
                              </strong>
                              {{ old.supervisors[0].doi3 }}
                            </li>

                            <br />
                            <li>
                              <strong class="text-primary"
                                >شناسه دیجیتالی مقاله (چهارم):
                              </strong>
                              {{ old.supervisors[0].doi4 }}
                            </li>

                            <br />
                            <li>
                              <strong class="text-primary"
                                >شناسه دیجیتالی مقاله (پنجم):
                              </strong>
                              {{ old.supervisors[0].doi5 }}
                            </li>
                          </div>
                          <br />
                          <b-form-group>
                            <div class="d-flex" dir="rtl">
                              <b-form-checkbox
                                :value="true"
                                v-model="old.supervisors[0].internationalPatent"
                              ></b-form-checkbox>
                              <label class="ml-2"
                                ><h6 class="text-primary">
                                  ثبت اختراع بین‌المللی
                                </h6></label
                              >
                            </div>
                          </b-form-group>

                          <div v-if="old.supervisors[0].internationalPatent">
                            <b-row>
                              <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                                <strong class="text-primary"
                                  >عنوان اختراع: </strong
                                >{{
                                  old.supervisors[0].internationalPatentTitle
                                }}
                              </b-col>
                              <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                                <strong class="text-primary"
                                  >سال اختراع: </strong
                                >{{
                                  old.supervisors[0].internationalPatentYear
                                }}
                              </b-col>
                            </b-row>
                            <b-row class="my-0 py-0">
                              <b-col cols="12">
                                <strong class="text-primary"
                                  >توضیحات اختراع: </strong
                                >{{
                                  old.supervisors[0]
                                    .internationalPatentDescription
                                }}
                              </b-col>
                            </b-row>
                          </div>
                          <br />
                          <b-form-group disabled class="mt-2">
                            <div class="d-flex" dir="rtl">
                              <b-form-checkbox
                                :value="true"
                                v-model="old.supervisors[0].researchFestivals"
                              ></b-form-checkbox>
                              <label class="ml-2"
                                ><h6 class="text-primary">
                                  اعضای برگزیده جشنواره های پژوهشی
                                </h6></label
                              >
                            </div>
                          </b-form-group>
                          <li v-if="old.supervisors[0].researchFestivals">
                            <strong class="text-primary"
                              >عنوان جشنواره:
                            </strong>
                            {{ old.supervisors[0].researchFestivalsTitle }}
                          </li>
                          <br />
                          <b-form-group class="mt-2" disabled>
                            <div class="d-flex" dir="rtl">
                              <b-form-checkbox
                                :value="true"
                                v-model="old.supervisors[0].notSupervisor"
                              ></b-form-checkbox>
                              <label class="ml-2"
                                ><h6 class="text-primary">
                                  اگر استاد راهنمای متقاضی نیستید تیک را بزنید
                                </h6></label
                              >
                            </div>
                          </b-form-group>
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button block v-b-toggle.accordion-5 variant="info">
                        <h5
                          class="mb-0 text-white"
                          style="display: inline-block"
                        >
                          مشخصات دوره
                        </h5>
                      </b-button>
                    </b-card-header>
                    <b-collapse
                      id="accordion-5"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text class="shadow p-3">
                          <ul>
                            <li>
                              <strong class="text-primary">چکیده دوره: </strong
                              >{{ old.abstract }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >ضرورت اجرای دوره (در جهت دستیابی به اهداف ستاد
                                و یا راهبردها و اقدامات سند توسعه زیست فناوری): </strong
                              >{{ old.requestNecessity }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >اهداف کلان دوره:</strong
                              >{{ old.majorGoals }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >اهداف خرد دوره:</strong
                              >{{ old.minorGoals }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >مزایای دیگر برای کشور: </strong
                              >{{ old.benefitsToCountry }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >روش شناسی (متدولوژی) و مراحل انجام دوره: </strong
                              >{{ old.methodology }}
                            </li>
                            <li v-if="old.requestProducts.length > 0">
                              <strong class="text-primary"
                                >دستاوردهای عینی و خروجی‌های ملموس(محصول/
                                محصولات و یا خدمات) حاصل از اجرای دوره:
                              </strong>
                              <!-- NOTE (t-old.requestProducts-2) previous -->
                              <b-table
                                responsive
                                small
                                show-empty
                                head-variant="dark"
                                :items="old.requestProducts"
                                :fields="achievmentFields"
                                empty-text="رکوردی برای نمایش وجود ندارد"
                                class="table table-secondary my-3"
                              >
                                <template v-slot:head()="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                    "
                                  >
                                    {{ data.label }}
                                  </div>
                                </template>
                                <template v-slot:cell()="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                    "
                                  >
                                    {{ data.value }}
                                  </div>
                                </template>
                                <template v-slot:cell(index)="data">
                                  <div
                                    style="
                                      text-align: center;
                                      vertical-align: middle;
                                    "
                                  >
                                    {{ data.index + 1 }}
                                  </div>
                                </template>
                              </b-table>
                            </li>
                            <li>
                              <strong class="text-primary"
                                >سابقه اجرائی یا دوره‌های مشابه در ایران یا خارج
                                از كشور (با ذكر ماخذ): </strong
                              >{{ old.executionHistorySimilar }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >شركای بین‌المللی در اجرای دوره :
                              </strong>
                              {{ old.internationalPartners }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >منابع و ماخذ: </strong
                              >{{ old.references }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >حمایتهای احتمالی قبلی ستاد از دوره:
                              </strong>
                              {{ old.postDocLastSupports }}
                            </li>
                          </ul>
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button block v-b-toggle.accordion-7 variant="light">
                        <h5 class="mb-0" style="display: inline-block">
                          زمان‌بندی دوره
                        </h5>
                      </b-button>
                    </b-card-header>
                    <b-collapse
                      id="accordion-7"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text class="p-3 shadow">
                          زمان شروع:
                          {{
                            old.gantData.length > 0
                              ? moment(
                                  new Date(
                                    Math.min(
                                      ...old.gantData.map((x) =>
                                        new Date(
                                          moment(
                                            x.startDate,
                                            "jYYYY/jMM/jDD"
                                          ).format("YYYY-MM-DD")
                                        ).getTime()
                                      )
                                    )
                                  )
                                ).format("jYYYY/jMM/jDD")
                              : ""
                          }}
                          <br />
                          زمان پایان:
                          {{
                            old.gantData.length > 0
                              ? moment(
                                  new Date(
                                    Math.max(
                                      ...old.gantData.map((x) =>
                                        new Date(
                                          moment(
                                            x.dueDate,
                                            "jYYYY/jMM/jDD"
                                          ).format("YYYY-MM-DD")
                                        ).getTime()
                                      )
                                    )
                                  )
                                ).format("jYYYY/jMM/jDD")
                              : ""
                          }}
                          <br />
                          مدت زمان:
                          {{
                            old.gantData.length > 0
                              ? (Math.max(
                                  ...old.gantData.map((x) =>
                                    new Date(
                                      moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                        "YYYY-MM-DD"
                                      )
                                    ).getTime()
                                  )
                                ) -
                                  Math.min(
                                    ...old.gantData.map((x) =>
                                      new Date(
                                        moment(
                                          x.startDate,
                                          "jYYYY/jMM/jDD"
                                        ).format("YYYY-MM-DD")
                                      ).getTime()
                                    )
                                  )) /
                                  3600 /
                                  24 /
                                  1000 +
                                " روز"
                              : ""
                          }}
                          <br />
                          <div>
                            <sarmadGantt
                              :items="old.gantData"
                              :fields="serviceFields"
                            />
                          </div>
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button block v-b-toggle.accordion-8 variant="dark">
                        <h5 class="mb-0" style="display: inline-block">
                          هزینه‌ها
                        </h5>
                      </b-button>
                    </b-card-header>
                    <b-collapse
                      id="accordion-8"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text class="shadow p-3">
                          <div v-if="old.personnelCosts.length > 0">
                            <hr />
                            <h5 class="mt-5 mb-3 text-primary">
                              هزینه‌های پرسنلی اعم از مجری و همكاران
                            </h5>

                            <!-- NOTE (t-personnelCost2) previous -->
                            <b-table
                              responsive
                              small
                              show-empty
                              head-variant="dark"
                              :items="old.personnelCosts"
                              :fields="PersonnelCostField"
                              empty-text="رکوردی برای نمایش وجود ندارد"
                              class="table table-secondary mb-4"
                            >
                              <template v-slot:head()="data">
                                <div
                                  style="
                                    text-align: center;
                                    vertical-align: middle;
                                  "
                                >
                                  {{ data.label }}
                                </div>
                              </template>
                              <template v-slot:cell()="data">
                                <div
                                  style="
                                    text-align: center;
                                    vertical-align: middle;
                                  "
                                >
                                  {{ data.value }}
                                </div>
                              </template>
                              <template v-slot:cell(index)="data">
                                <div
                                  style="
                                    text-align: center;
                                    vertical-align: middle;
                                  "
                                >
                                  {{ data.index + 1 }}
                                </div>
                              </template>
                              <template v-slot:cell(humanResourceCost)="data">
                                <div>
                                  {{
                                    (
                                      parseInt(data.item.perPersonCost) *
                                      parseInt(data.item.cooperationHour)
                                    ).toLocaleString()
                                  }}
                                </div>
                              </template>
                            </b-table>
                            <!-- {{old.personnelCosts.map(x=>x.humanResourceCost).reduce((a,b)=>(parseInt(a)+parseInt(b)))}} -->
                            <p>
                              جمع کل هزینه های پرسنلی:
                              {{
                                old.personnelCosts.length == 0
                                  ? 0
                                  : old.personnelCosts
                                      .map(
                                        (x) =>
                                          parseInt(x.perPersonCost) *
                                          parseInt(x.cooperationHour)
                                      )
                                      .reduce(
                                        (a, b) => parseInt(a) + parseInt(b),
                                        0
                                      )
                                      .toLocaleString()
                              }}
                              تومان
                            </p>
                          </div>

                          <div v-if="old.travelExpenses.length > 0">
                            <h5 class="mt-5 mb-3 text-primary">
                              هزینه مسافرت‌های ضروری (اعم از هزینه بلیط، اسكان،
                              غذا، حمل و نقل، حق مأموریت و ...):
                            </h5>

                            <!-- NOTE (t-tripCost2) previous -->
                            <b-table
                              responsive
                              small
                              show-empty
                              head-variant="dark"
                              :items="old.travelExpenses"
                              :fields="tripCostField"
                              empty-text="رکوردی برای نمایش وجود ندارد"
                              class="table table-secondary mb-4"
                            >
                              <template v-slot:head()="data">
                                <div
                                  style="
                                    text-align: center;
                                    vertical-align: middle;
                                  "
                                >
                                  {{ data.label }}
                                </div>
                              </template>
                              <template v-slot:cell()="data">
                                <div
                                  style="
                                    text-align: center;
                                    vertical-align: middle;
                                  "
                                >
                                  {{ data.value }}
                                </div>
                              </template>
                              <template v-slot:cell(index)="data">
                                <div
                                  style="
                                    text-align: center;
                                    vertical-align: middle;
                                  "
                                >
                                  {{ data.index + 1 }}
                                </div>
                              </template>
                            </b-table>
                            جمع کل مسافرتهای ضروری:
                            {{
                              old.travelExpenses.length == 0
                                ? 0
                                : old.travelExpenses
                                    .map((x) => x.cost)
                                    .reduce(
                                      (a, b) => parseInt(a) + parseInt(b),
                                      0
                                    )
                                    .toLocaleString()
                            }}
                            تومان
                          </div>
                          <div v-if="old.purchases.length > 0">
                            <h5 class="mt-5 mb-3 text-primary">
                              هزینه دستگاه‌ها، وسایل و مواد مورد نیازكه باید از
                              محل اعتبار طرح خریداری شوند:
                            </h5>

                            <!-- NOTE (t-deviceCost2) previous -->
                            <b-table
                              responsive
                              small
                              show-empty
                              head-variant="dark"
                              :items="old.purchases"
                              :fields="deviceCostField"
                              empty-text="رکوردی برای نمایش وجود ندارد"
                              class="table table-secondary"
                            >
                              <template v-slot:head()="data">
                                <div
                                  style="
                                    text-align: center;
                                    vertical-align: middle;
                                  "
                                >
                                  {{ data.label }}
                                </div>
                              </template>
                              <template v-slot:cell()="data">
                                <div
                                  style="
                                    text-align: center;
                                    vertical-align: middle;
                                  "
                                >
                                  {{ data.value }}
                                </div>
                              </template>
                              <template v-slot:cell(index)="data">
                                <div
                                  style="
                                    text-align: center;
                                    vertical-align: middle;
                                  "
                                >
                                  {{ data.index + 1 }}
                                </div>
                              </template>
                              <template v-slot:cell(totalPrice)="data">
                                <div>
                                  {{
                                    (
                                      parseInt(data.item.number) *
                                      parseInt(data.item.perPrice)
                                    ).toLocaleString()
                                  }}
                                </div>
                              </template>
                            </b-table>
                            جمع کل هزینه دستگاه‌ها:
                            {{
                              old.purchases.length == 0
                                ? 0
                                : old.purchases
                                    .map(
                                      (x) =>
                                        parseInt(x.perPrice) *
                                        parseInt(x.number)
                                    )
                                    .reduce(
                                      (a, b) => parseInt(a) + parseInt(b),
                                      0
                                    )
                                    .toLocaleString()
                            }}
                            تومان
                            <hr />
                          </div>

                          <div
                            v-if="
                              old.participationOrganizationBudget.length > 0
                            "
                          >
                            <h5 class="mt-5 mb-3 text-primary">
                              میزان مشارکت سایر موسسات:
                            </h5>

                            <!-- NOTE (t-orgCost2) previous -->
                            <b-table
                              responsive
                              small
                              show-empty
                              head-variant="dark"
                              :items="old.participationOrganizationBudget"
                              :fields="OrgCostField"
                              empty-text="رکوردی برای نمایش وجود ندارد"
                              class="table table-secondary"
                            >
                              <template v-slot:head()="data">
                                <div
                                  style="
                                    text-align: center;
                                    vertical-align: middle;
                                  "
                                >
                                  {{ data.label }}
                                </div>
                              </template>
                              <template v-slot:cell()="data">
                                <div
                                  style="
                                    text-align: center;
                                    vertical-align: middle;
                                  "
                                >
                                  {{ data.value }}
                                </div>
                              </template>
                              <template v-slot:cell(index)="data">
                                <div
                                  style="
                                    text-align: center;
                                    vertical-align: middle;
                                  "
                                >
                                  {{ data.index + 1 }}
                                </div>
                              </template>
                            </b-table>
                            جمع کل مشارکت موسسات:
                            {{
                              old.participationOrganizationBudget.length == 0
                                ? 0
                                : old.participationOrganizationBudget
                                    .map((x) => x.totalPrice)
                                    .reduce(
                                      (a, b) => parseInt(a) + parseInt(b),
                                      0
                                    )
                                    .toLocaleString()
                            }}
                            تومان
                          </div>
                          <div
                            v-show="
                              old.otherCosts
                                .map((x) => x.totalPrice)
                                .reduce(
                                  (a, b) => parseInt(a) + parseInt(b),
                                  0
                                ) > 0
                            "
                          >
                            <h5 class="mt-5 mb-3 text-primary">
                              هزینه‌های دیگر:
                            </h5>

                            <!-- NOTE (t-otherCost2) previous -->
                            <b-table
                              responsive
                              small
                              show-empty
                              head-variant="dark"
                              :items="old.otherCosts"
                              :fields="otherCostField"
                              empty-text="رکوردی برای نمایش وجود ندارد"
                              class="table table-secondary"
                            >
                              <template v-slot:head()="data">
                                <div
                                  style="
                                    text-align: center;
                                    vertical-align: middle;
                                  "
                                >
                                  {{ data.label }}
                                </div>
                              </template>
                              <template v-slot:cell()="data">
                                <div
                                  style="
                                    text-align: center;
                                    vertical-align: middle;
                                  "
                                >
                                  {{ data.value }}
                                </div>
                              </template>
                              <template v-slot:cell(index)="data">
                                <div
                                  style="
                                    text-align: center;
                                    vertical-align: middle;
                                  "
                                >
                                  {{ data.index + 1 }}
                                </div>
                              </template>
                            </b-table>
                            <p>
                              جمع کل سایر هزینه‌ها:
                              {{
                                old.otherCosts.length == 0
                                  ? 0
                                  : old.otherCosts
                                      .map((x) => x.totalPrice)
                                      .reduce(
                                        (a, b) => parseInt(a) + parseInt(b),
                                        0
                                      )
                                      .toLocaleString()
                              }}
                              تومان
                            </p>
                          </div>
                          <h3>
                            جمع کل هزینه‌ها:
                            {{
                              (tPrice = (
                                (old.personnelCosts.length == 0
                                  ? 0
                                  : old.personnelCosts
                                      .map(
                                        (x) =>
                                          parseInt(x.perPersonCost) *
                                          parseInt(x.cooperationHour)
                                      )
                                      .reduce(
                                        (a, b) => parseInt(a) + parseInt(b),
                                        0
                                      )) +
                                (old.travelExpenses.length == 0
                                  ? 0
                                  : old.travelExpenses
                                      .map((x) => x.cost)
                                      .reduce(
                                        (a, b) => parseInt(a) + parseInt(b),
                                        0
                                      )) +
                                (old.purchases.length == 0
                                  ? 0
                                  : old.purchases
                                      .map(
                                        (x) =>
                                          parseInt(x.perPrice) *
                                          parseInt(x.number)
                                      )
                                      .reduce(
                                        (a, b) => parseInt(a) + parseInt(b),
                                        0
                                      )) +
                                (old.otherCosts.length == 0
                                  ? 0
                                  : old.otherCosts
                                      .map((x) => x.totalPrice)
                                      .reduce(
                                        (a, b) => parseInt(a) + parseInt(b),
                                        0
                                      ))
                              ).toLocaleString())
                            }}
                            تومان
                          </h3>
                          <hr />
                          <h3>
                            میزان اعتبار مورد نیاز از ستاد زیست فناوری:
                            {{ computedTotalCost.toLocaleString() }}
                            تومان
                          </h3>
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button block v-b-toggle.accordion-9 variant="dark">
                        <h5 class="mb-0" style="display: inline-block">
                          تعهدات
                        </h5>
                      </b-button>
                    </b-card-header>
                    <b-collapse
                      id="accordion-9"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text class="shadow p-3">
                          <b-form-group disabled>
                            <b-form-checkbox
                              :class="
                                old.promiseArrays[0] ? 'done' : 'required'
                              "
                              v-model="old.promiseArrays[0]"
                            >
                              این طرح در مدت زمان اعلام شده در پروپوزال انجام
                              می‌گردد و مسئولیت تاخیر در انجام طرح بر عهده مجری
                              می‌باشد. مدت زمان:
                              {{
                                old.gantData.length > 0
                                  ? (Math.max(
                                      ...old.gantData.map((x) =>
                                        new Date(
                                          moment(
                                            x.dueDate,
                                            "jYYYY/jMM/jDD"
                                          ).format("YYYY-MM-DD")
                                        ).getTime()
                                      )
                                    ) -
                                      Math.min(
                                        ...old.gantData.map((x) =>
                                          new Date(
                                            moment(
                                              x.startDate,
                                              "jYYYY/jMM/jDD"
                                            ).format("YYYY-MM-DD")
                                          ).getTime()
                                        )
                                      )) /
                                      3600 /
                                      24 /
                                      1000 +
                                    " روز"
                                  : ""
                              }}
                            </b-form-checkbox>
                            <b-form-checkbox
                              :class="
                                old.promiseArrays[1] ? 'done' : 'required'
                              "
                              v-model="old.promiseArrays[1]"
                            >
                              این طرح با بودجه اعلام شده در پروپوزال انجام
                              می‌گردد. هزینه انجام:
                              {{
                                (tPrice = (
                                  (old.personnelCosts.length == 0
                                    ? 0
                                    : old.personnelCosts
                                        .map(
                                          (x) =>
                                            parseInt(x.perPersonCost) *
                                            parseInt(x.cooperationHour)
                                        )
                                        .reduce(
                                          (a, b) => parseInt(a) + parseInt(b),
                                          0
                                        )) +
                                  (old.travelExpenses.length == 0
                                    ? 0
                                    : old.travelExpenses
                                        .map((x) => x.cost)
                                        .reduce(
                                          (a, b) => parseInt(a) + parseInt(b),
                                          0
                                        )) +
                                  (old.purchases.length == 0
                                    ? 0
                                    : old.purchases
                                        .map(
                                          (x) =>
                                            parseInt(x.perPrice) *
                                            parseInt(x.number)
                                        )
                                        .reduce(
                                          (a, b) => parseInt(a) + parseInt(b),
                                          0
                                        )) +
                                  (old.otherCosts.length == 0
                                    ? 0
                                    : old.otherCosts
                                        .map((x) => x.totalPrice)
                                        .reduce(
                                          (a, b) => parseInt(a) + parseInt(b),
                                          0
                                        ))
                                ).toLocaleString())
                              }}
                              تومان
                            </b-form-checkbox>
                            <b-form-checkbox
                              :class="
                                old.promiseArrays[2] ? 'done' : 'required'
                              "
                              v-model="old.promiseArrays[2]"
                              >کلیه حقوق مادی و معنوی این طرح متعلق به ستاد زیست
                              فناوری می‌باشد.</b-form-checkbox
                            >
                            <b-form-checkbox
                              :class="
                                old.promiseArrays[3] ? 'done' : 'required'
                              "
                              v-model="old.promiseArrays[3]"
                              >توافق بین دانشگاه و صنعت در خصوص دستاوردهای طرح
                              وجود دارد.</b-form-checkbox
                            >
                            <b-form-checkbox
                              :class="
                                old.promiseArrays[4] ? 'done' : 'required'
                              "
                              v-model="old.promiseArrays[4]"
                              >نحوه و مسیر تجاری سازی طرح مشخص است و مستندات
                              ارائه شده است.</b-form-checkbox
                            >
                            <b-form-checkbox
                              :class="
                                old.promiseArrays[5] ? 'done' : 'required'
                              "
                              v-model="old.promiseArrays[5]"
                            >
                              بهره‌بردار نهایی طرح مشخص است و مستندات ارائه شده
                              است. نام بهره‌بردار:
                              {{
                                (old.researcherName
                                  ? old.researcherName
                                  : "-") +
                                " " +
                                (old.researcherLastName
                                  ? old.researcherLastName
                                  : "")
                              }}
                            </b-form-checkbox>
                            <b-form-checkbox
                              :class="
                                old.promiseArrays[6] ? 'done' : 'required'
                              "
                              v-model="old.promiseArrays[6]"
                              >حداقل 1 مقاله ISI معتبر به عنوان خروجی طرح تعهد
                              می‌شود.</b-form-checkbox
                            >
                            <b-form-checkbox
                              :class="
                                old.promiseArrays[7] ? 'done' : 'required'
                              "
                              v-model="old.promiseArrays[7]"
                              >تمامی گزارش‌ها پیشرفت در موعد مقرر مطابق با گانت
                              چارت انجام خواهد شد.</b-form-checkbox
                            >
                            <b-form-checkbox
                              :class="
                                old.promiseArrays[8] ? 'done' : 'required'
                              "
                              v-model="old.promiseArrays[8]"
                              >کلیه گزارش‌ها و خروجی‌ها و دستاوردهای طرح در
                              پایان انجام طرح به ستاد زیست فناوری ارسال و تحویل
                              داده می‌شود.</b-form-checkbox
                            >
                            <b-form-checkbox
                              :class="
                                old.promiseArrays[9] ? 'done' : 'required'
                              "
                              v-model="old.promiseArrays[9]"
                              >کلیه اصلاحات در مورد مقرر و طی 2 هفته توسط مجری
                              انجام و در سایت بارگذاری می‌گردد.</b-form-checkbox
                            >
                            <b-form-checkbox
                              :class="
                                old.promiseArrays[10] ? 'done' : 'required'
                              "
                              v-model="old.promiseArrays[10]"
                              >ثبت اطلاعات در سامانه هیچ تعهدی را برای ستاد
                              ایجاد نمی‌کند و به منزله ثبت درخواست متقاضی
                              است.</b-form-checkbox
                            >
                            <b-form-checkbox
                              :class="
                                old.promiseArrays[11] ? 'done' : 'required'
                              "
                              v-model="old.promiseArrays[11]"
                              >سوابق پژوهشگر با موضوع دوره منطبق
                              است.</b-form-checkbox
                            >
                            <b-form-checkbox
                              :class="
                                old.promiseArrays[12] ? 'done' : 'required'
                              "
                              v-model="old.promiseArrays[12]"
                              >سوابق استاد راهنما با موضوع دوره منطبق
                              است.</b-form-checkbox
                            >
                            <b-form-checkbox
                              :class="
                                old.promiseArrays[13] ? 'done' : 'required'
                              "
                              v-model="old.promiseArrays[13]"
                              >کلیه موارد فوق مورد تایید اینجانب
                              {{
                                (old.researcherName
                                  ? old.researcherName
                                  : "-") +
                                " " +
                                old.researcherLastName
                              }}
                              به عنوان مجری طرح و همکاران
                              می‌باشد.</b-form-checkbox
                            >
                          </b-form-group>
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </b-tab>
                <b-tab title="اطلاعات تجاری‌سازی">
                  <v-row class="px-4">
                    <v-col>
                      <h4 class="c-dark mt-2">
                        نوع تجاری‌سازی:
                        {{
                          old.commercializingType == "company"
                            ? "شرکت دانش بنیان"
                            : old.commercializingType == "accelerator"
                            ? "شتاب‌دهنده"
                            : "فاقد اطلاعات تجاری‌سازی می‌باشد"
                        }}
                      </h4>
                    </v-col>
                  </v-row>
                  <b-card-body>
                    <b-card-text class="shadow p-3">
                      <div v-if="old.commercializingType == 'company'">
                        <ul>
                          <div v-if="old.companyId != notCompany">
                            <li>
                              <strong class="text-primary"
                                >نام شرکت دانش بنیان: </strong
                              >{{ old.companyName }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >شماره ثبت شرکت: </strong
                              >{{
                                old.companyRegistrationNumber
                                  ? old.companyRegistrationNumber
                                  : "-"
                              }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >شناسه ملی شرکت: </strong
                              >{{
                                old.companyNationalId
                                  ? old.companyNationalId
                                  : "-"
                              }}
                            </li>
                          </div>
                          <div v-else>
                            <li>
                              <strong class="text-primary"
                                >نام شرکت دانش بنیان: </strong
                              >{{ old.otherCompanyName }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >شماره ثبت شرکت:
                              </strong>
                              {{ old.otherCompanyRegistrationNumber }}
                            </li>
                            <li>
                              <strong class="text-primary"
                                >شناسه ملی شرکت: </strong
                              >{{ old.otherCompanyNationalId }}
                            </li>
                          </div>
                          <li>
                            <strong class="text-primary"
                              >معرفی فناوری یا محصولات شرکت:
                            </strong>
                            {{ old.companyProducts }}
                          </li>
                          <li>
                            <strong class="text-primary"
                              >آدرس پستی / شماره تماس/ پست الکترونیک شرکت:
                            </strong>
                            {{ old.companyContactInfo }}
                          </li>
                        </ul>
                      </div>
                      <ul v-else-if="old.commercializingType == 'accelerator'">
                        <li>
                          <strong class="text-primary">نام شتاب‌دهنده:</strong>

                          {{ old.acceleratorName }}
                        </li>
                      </ul>
                      <div v-else-if="old.commercializingType == 'none'">
                        <div class="d-flex flex-row mb-2">
                          <b-form-checkbox
                            disabled
                            v-model="old.commercializingObligation1"
                            @change="reactivity = !reactivity"
                          ></b-form-checkbox
                          ><span class="ps-2">
                            تایید میکنم با انتخاب این گزینه تا قبل از تایید
                            درخواست توسط یکی از شتاب‌دهنده‌ها یا شرکت‌های مجاز،
                            ستاد توسعه زیست فناوری هیچگونه مسئولیتی در قبال
                            درخواست من نخواهد داشت.
                          </span>
                        </div>
                        <div class="d-flex flex-row mb-2">
                          <b-form-checkbox
                            disabled
                            v-model="old.commercializingObligation2"
                            @change="reactivity = !reactivity"
                          ></b-form-checkbox>
                          <span class="ps-2">
                            تایید میکنم با انتخاب این گزینه، کلیه اطلاعات شخصی و
                            علمی این درخواست، در اختیار شتاب‌دهنده‌ها و شرکت‌های
                            مجاز قرار خواهد گرفت تا بتوانند با بررسی اطلاعات،
                            درخواست بنده را بررسی و تایید کنند.
                          </span>
                        </div>
                      </div>
                      <h5 class="text-primary">
                        ملاحظات مربوط به همکاری طرفین، بازار و عایدی دوره
                      </h5>
                      <ul>
                        <li>
                          <strong class="text-primary"
                            >نحوه تعامل با دانشگاه یا مراکز و ملاحظات مربوط به
                            حق
                            <strong class="text-primary"
                              >مالکیت:
                            </strong></strong
                          >
                          {{ old.interactUniversityCenters }}
                        </li>
                        <li>
                          <strong class="text-primary">معرفی بازار هدف: </strong
                          >{{ old.targetMarket }}
                        </li>
                        <li>
                          <strong class="text-primary"
                            >پیش بینی میزان فروش محصول در سه سال اول:
                          </strong>
                          {{ old.productSalesForecast }}
                        </li>
                        <li>
                          <strong class="text-primary"
                            >میزان اشتغال زایی دوره: </strong
                          >{{ old.employment }}
                        </li>
                        <li>
                          <strong class="text-primary"
                            >برآورد مدت زمان همکاری: </strong
                          >{{ old.durationCooperation }}
                        </li>
                        <li>
                          <strong class="text-primary"
                            >برآورد میزان تولید و عایدی دوره:
                          </strong>
                          {{ old.estimationProductionProjectRevenue }}
                        </li>
                        <li>
                          <strong class="text-primary"
                            >محصولات رقیب و میزان رقابت پذیری(مقایسه قیمت) (در
                            صورت وجود):
                          </strong>
                          {{ old.competitiveProductsLevelCompetitiveness }}
                        </li>
                        <li>
                          <strong class="text-primary"
                            >مزیت محصول نسبت به موارد مشابه و موجود:
                          </strong>
                          {{ old.productAdvantages }}
                        </li>
                      </ul>
                    </b-card-text>
                  </b-card-body>
                </b-tab>
                <b-tab title="فایل های تکمیلی">
                  <h6>
                    <b-input-group size="md">
                      <b-form-input
                        trim
                        v-model="fileFilter"
                        type="search"
                        id="filterInput"
                        placeholder="جستجو"
                      ></b-form-input>
                      <b-input-group-append>
                        <!-- NOTE (b-delete) to delete the text of the search bar -->
                        <b-button
                          :disabled="!fileFilter"
                          @click="fileFilter = ''"
                          variant="danger"
                          >حذف</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                  </h6>

                  <!-- NOTE (t-files) to show the proposal files -->
                  <b-table
                    responsive
                    show-empty
                    head-variant="dark"
                    :fields="fileFields"
                    :items="old.uploadedFiles.filter((x) => x && x.url != '')"
                    :filter="fileFilter"
                    empty-text="فایلی برای نمایش وجود ندارد"
                    empty-filtered-text="فایلی برای نمایش وجود ندارد"
                    striped
                    :busy="fileBusy"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(url)="data">
                      <div style="text-align: center; vertical-align: middle">
                        <!-- NOTE (<a>) to download the uploaded files by opening a new page -->
                        <a
                          v-if="data.value"
                          class="btn btn-success white--text"
                          :href="data.value"
                          target="_blank"
                          >دریافت فایل</a
                        >
                      </div>
                    </template>
                    <template v-slot:cell(title)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ fileTitles[data.index] }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                    <div slot="table-busy" class="text-center text-danger my-2">
                      <strong class="text-primary">در حال بارگذاری...</strong>
                      <br />
                      <b-spinner class="align-middle"></b-spinner>
                    </div>
                  </b-table>
                </b-tab>
              </b-tabs>
            </b-tab>
          </b-tabs>
        </b-tab>
        <b-tab
          v-if="role == 'manager' && proposal.status == 'پذیرش اولیه'"
          title="مدیریت وضعیت"
        >
          <b-card header-bg-variant="default" class="border-0 shadow-sm">
            <template v-slot:header>
              <h4 class="mb-0">مدیریت وضعیت&nbsp;</h4>
            </template>

            <b-form-group
              id="fieldset-1"
              description
              label="وضعیت طرح"
              aria-invalid="comments"
            >
              <b-form-group>
                <Select2
                  v-model="selectedSituation"
                  :options="[
                    { id: 'finalAccept', text: 'تایید نهایی' },
                    { id: 'rejected', text: 'رد شده است' },
                  ]"
                  :settings="{ width: '75%' }"
                ></Select2>
                <!-- <b-form-select v-model="selectedStatus" :options="statusOptions"></b-form-select> -->
              </b-form-group>

              <b-form-group
                label="دلایل رد درخواست"
                v-if="selectedSituation == 'rejected'"
              >
                <v-select
                  multiple
                  :reduce="(x) => x.code"
                  :options="rejectOptions"
                  v-model="rejectCause"
                >
                </v-select>
              </b-form-group>
              <b-form-group v-else-if="selectedStatus == 3"></b-form-group>

              <b-form-group>
                <!-- NOTE (b-rejection) to submit reason for rejection -->
                <b-button
                  :disabled="disableEditProposal"
                  @click="editProposalManager"
                  >ثبت</b-button
                >
              </b-form-group>
            </b-form-group>
          </b-card>
        </b-tab>
        <b-tab v-if="role == 'referee'" title="داوری">
          <Review />
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import moment from "moment-jalaali"; // NOTE (IMPORT) to convert dates to each other
import Review from "./PostDocReview"; // NOTE (IMPORT) to use reviewing component
import AcceleratorReview from "./AcceleratorReview";
import { EventBus } from "../main"; // REVIEW
const sarmadGantt = () => import("./sarmadGantt");
import Select2 from "v-select2-component"; // NOTE (IMPORT) to add an option to universitys drop down list which allow to user to type and search
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection tool for persian date & time

export default {
  name: "PostDoc",
  props: ["role"],
  components: {
    datePicker: VuePersianDatetimePicker,
    Select2, // NOTE (COMPONENT) component of select2 plugin
    Review,
    AcceleratorReview,
    sarmadGantt: sarmadGantt, // NOTE (COMPONENT) component of sarmad gantt chart
  },
  data() {
    return {
      refereeErrorHandler: false,
      expireDisable: false,
      pageLoaded: false,
      statusDictionary: [
        { en: "Done", fa: "تمام" },
        { en: "NotDone", fa: "ناتمام" },
        { en: "Expired", fa: "منقضی" },
      ],
      rejectCause: [],
      rejectOptions: [],
      infoo: "",
      promises: {},
      eduGradeOptions: [
        "--مقطع را انتخاب کنید",
        "کارشناسی",
        "کارشناسی ارشد",
        "دکتری",
        "دکتری حرفه ای",
      ],
      fileBusy: true,
      selectedStatus: null,
      selectedSituation: "",
      comments: "",
      reviewersData: [],
      reviewersFields: [],
      judgements: [],
      selectedJudgement: {},
      journalsFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام" },
        { key: "message", label: "پیام" },
        { key: "date", label: "تاریخ" },
      ],
      judgementFields: [
        { key: "index", label: "#" },
        { key: "status", label: "وضعیت" },
        { key: "referee", label: "داور" },
        { key: "decision", label: "تصمیم" },
        { key: "judgeDate", label: "تاریخ داوری" },
        { key: "description", label: "توضیحات" },
      ],
      reviewers: [],
      situationsOptions: [
        {
          id: 12,
          eng: "draf",
          text: "پیش نویس",
          disabled: true,
        },
        {
          id: 11,
          eng: "waitingforCommercializing",
          text: "در انتظار بهره‌بردار",
          disabled: true,
        },
        { id: 1, eng: "registered", text: "ثبت شده" },
        { id: 2, eng: "underSupervision", text: "درحال بررسی" },
        { id: 3, eng: "inviteReviewers", text: "در دست داوری" },
        { id: 4, eng: "reviewDone", text: "جمع بندی نظرات داوران" },
        { id: 5, eng: "approve", text: "پذیرش اولیه" },
        { id: 6, eng: "corrected", text: "اصلاح شده" },
        { id: 7, eng: "finalAccept", text: "تایید نهایی" },
        { id: 8, eng: "incomplete", text: "نیاز به تکمیل / اصلاح" },
        { id: 9, eng: "reject", text: "رد شده است" },
        { id: 10, eng: "declined", text: "لغو" },
      ],
      selectedReferee: "",
      adminMessage: "",
      reportItems: [],
      reportFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "عنوان گزارش" },
        { key: "date", label: "تاریخ گزارش" },
        { key: "operation", label: "" },
      ],
      fileItems: [],
      filesFields: [
        { key: "index", label: "ردیف" },
        { key: "title", label: "عنوان فایل" },
        { key: "date", label: "تاریخ گزارش" },
        { key: "operation", label: "" },
      ],
      haveReferee: null,
      contract: null,

      acc: 0,
      moment: moment,
      show: false,
      checkbox: "",
      checkbox2: "",
      busy: false,
      initial: {},
      doi: "",
      code: {},
      source: "",
      specs: {},
      colleaguesData: [],
      selectedColleague: "",
      executor: {},
      proposal: {
        initialIsSupported: null,
      },
      colleague: {},
      universities: [],
      mehvars: [],
      fileFilter: "",
      zone: new Array(6).fill(false),
      tabIndex: 0,
      options: [
        { text: "طرح", value: "project" },
        { text: "پایان‌نامه ارشد", value: "master" },
        { text: "رساله دکتری", value: "phd" },
        { text: "مقالات", value: "article" },
        { text: "نشست‌ها", value: "meeting" },
        { text: "دوره‌های پسادکتری", value: "postDoc" },
        { text: "فرصت‌های مطالعاتی", value: "opportune" },
        { text: "نخبگان وظیفه", value: "elite" },
        { text: "سایر", value: "other" },
      ],
      drPosition: ["مربی", "استادیار", "دانشیار", "استاد‌تمام"],
      committieType: ["وزارت علوم", "وزارت بهداشت"],
      lastDegree: ["کارشناسی", "کارشناسی ارشد", "دکتری"],
      support: "",
      supportSetad: "",
      dr: {},
      selectedMehvar: 0,
      taahol: "",
      DoiItem: [],
      DoiField: [
        { key: "subject", label: "عنوان" },
        { key: "mag", label: "مجله" },
        { key: "if", label: "IF" },
        { key: "year", label: "سال" },
      ],
      achievmentFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستاورد و خروجی" },
        { key: "amount", label: "کمی شده دستاورد و خروجی" },
        { key: "fullfill", label: "پیش بینی زمان تحقق دستاورد و خروجی (ماه)" },
      ],
      serviceFields: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
        { key: "cellColor", label: "رنگ" },
        { key: "operation", label: "" },
      ],
      serviceFieldsDoc: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
      ],
      tripCostField: [
        { key: "index", label: "#" },
        { key: "destination", label: "مقصد" },
        { key: "reason", label: "منظور از مسافرت" },
        { key: "number", label: "تعداد افراد" },
        // { key: "day", label: "نفر روز" },
        { key: "cost", label: "هزینه کل سفر" },
      ],
      perCosts: [
        {
          value: "دلار",
          text: "دلار",
        },
        {
          value: "تومان",
          text: "تومان",
        },
      ],
      perPrices: [
        {
          value: "دلار",
          text: "دلار",
        },
        {
          value: "تومان",
          text: "تومان",
        },
      ],
      adminToReferee: "",
      editCommercializationDialog: false,
      removeCommercializationDialog: false,
      removeLoading: false,
      newAcceleratorId: "",
      accelerators: [],
      options1: [
        {
          value: "کارشناسی",
          text: "کارشناسی",
        },
        {
          value: "کارشناسی ارشد",
          text: "کارشناسی ارشد",
        },
        {
          value: "دکتری",
          text: "دکتری",
        },
      ],
      options2: [
        {
          value: "تمام وقت",
          text: "تمام وقت",
        },
        {
          value: "پاره وقت",
          text: "پاره وقت",
        },
      ],
      sources: [
        {
          value: "داخلی",
          text: "داخلی",
        },
        {
          value: "خارجی",
          text: "خارجی",
        },
      ],

      deviceTypes: [
        { value: "مصرفی", text: "مصرفی" },
        { value: "سرمایه‌ای", text: "سرمایه‌ای" },
      ],
      PersonnelCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام و نام خانوادگی" },
        { key: "degree", label: "میزان تحصیلات" },
        { key: "cooperationType", label: "نوع همکاری" },
        { key: "cooperationHour", label: "هزینه نفر ساعت (تومان)" },
        { key: "perPersonCost", label: "نفر ساعت مورد نیاز" },
        {
          key: "humanResourceCost",
          label: "هزینه نیروی انسانی (تومان)",
        },
      ],
      inventionItem: [],
      rejectMessage: "",
      inventionField: [
        { key: "subject", label: "عنوان" },
        { key: "Iyear", label: "سال" },
        { key: "description", label: "توضیحات" },
      ],
      inventionFieldMaster: [
        { key: "Msubject", label: "عنوان" },
        { key: "Myear", label: "سال" },
        { key: "Mdescription", label: "توضیحات" },
      ],
      myFile: new Object({
        uploadPercentage: 0,
      }),
      fileFields: [
        { key: "index", label: "ردیف" },
        { key: "title", label: "عنوان" },
        { key: "showName", label: "نام فایل" },
        { key: "url", label: "دریافت" },
      ],
      fileTitles: [
        "نامه شورای پژوهش یا فناوری دانشگاه",
        "نامه صنعت یا شرکت",
        "توافقنامه دانشگاه با صنعت",
        "نامه اعلام شماره حساب هزینه ای دانشگاه",
        "رزومه استاد راهنما (فارسی)",
        "رزومه استاد راهنما (انگلیسی)",
        "رزومه متقاضی (فارسی)",
        "رزومه متقاضی (انگلیسی)",
        "حکم عضویت هیئت علمی استاد",
        "مقاله اول",
        "مقاله دوم",
        "مقاله سوم",
        "مقاله چهارم",
        "مقاله پنجم",
        "مدرک برگزیدگان جشنواره‌ها",
        "مستندات طرح های کاربردی",
        "مدرک دکتری پژوهشگر",
        "معرفی نامه",
      ],
      file: null,
      achievmentFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستاورد و خروجی" },
        { key: "amount", label: "کمی شده دستاورد و خروجی" },
        { key: "fullfill", label: "پیش بینی زمان تحقق دستاورد و خروجی (ماه)" },
      ],
      serviceFields: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
        { key: "cellColor", label: "رنگ" },
        { key: "operation", label: "" },
      ],
      additionalFiles: {
        zero: { uploadPercentage: 0 },
        research: { uploadPercentage: 0 },
        industry: { uploadPercentage: 0 },
        agreement: { uploadPercentage: 0 },
        others1: { uploadPercentage: 0 },
        others2: { uploadPercentage: 0 },
        others3: { uploadPercentage: 0 },
      },
      otherCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نوع هزینه‌ها" },
        { key: "totalPrice", label: "مبلغ" },
      ],
      allCostItem: [
        { name: "پرسنلی ", totalPrice: 0 },
        { name: "ارتباطات، حمل ونقل ، پست ، دورنویس و باربری", totalPrice: 0 },
        { name: "هزینه های پیش بینی نشده", totalPrice: 0 },
      ],
      allCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نوع هزینه‌ها" },
        { key: "پرسنلی ", label: "پرسنلی" },
      ],
      exportDate: moment(new Date()).format("jDD/jMM/jYYYY"),
      OrgCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام موسسه" },
        {
          key: "description",
          label: "نوع همكاری (شرح وظایف به طور دقیق و شفاف مشخص شود)",
        },
        { key: "totalPrice", label: "میزان مشارکت (تومان)" },
      ],
      deviceCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستگاه" },
        // { key: "consumable", label: "مصرفی" },
        // { key: "fund", label: "سرمایه‌ای" },
        { key: "type", label: "نوع" },
        { key: "source", label: "محل تامین", cssClass: "table-column" },
        { key: "number", label: "تعداد/میزان" },
        { key: "perPrice", label: "قیمت واحد به تومان" },
        { key: "totalPrice", label: "قیمت کل به تومان" },
      ],
      uploadedFiles: new Array(10).fill({
        title: "",
        description: "",
      }),
      otherFiles: new Array(10).fill({
        isUploaded: false,
      }),
      myshow: false,
      config: {
        locale: {
          name: "en",
        },
        height: 50,
        list: {
          rows: {},
          columns: {
            data: {
              id: {
                id: "id",
                data: "id",
                width: 50,
                header: {
                  content: "ردیف",
                },
              },
              label: {
                id: "label",
                data: "label",
                width: 200,
                header: {
                  content: "نام فعالیت",
                },
              },
              start: {
                id: "start",
                data: (start) => moment(start).format("jYYYY/jMM/jDD"),

                width: 200,
                header: {
                  content: "تاریخ آغاز",
                },
              },
              end: {
                id: "end",
                data: (end) => moment(end).format("jYYYY/jMM/jDD"),

                width: 200,
                header: {
                  content: "تاریخ پایان",
                },
              },
            },
          },
        },
        chart: {
          time: {
            zoom: 12,
          },
          items: {},
        },
      },
      background: [
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
        "#bd965c",
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
        "#bd965c",
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
      ],
      isLoaded: true,

      companies: [],
      isAccelerator: false,
    };
  },
  methods: {
    viewList() {
      localStorage.setItem("list", "accelerator");
      let link = "/map";
      window.open(link, "_blank");
    },
    saveDocx(element) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>sarmad</title><style>.done{color: black} .required{color:red} strong{font-family:B Titr;} table, td, th {border: 1px solid black} table {width:100%; border-collapse: collapse} .all{direction : rtl; text-align: right} body{font-family:B Nazanin;}</style></body></body></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msword",
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-word;charset=utf-8," +
        encodeURIComponent(html);

      // Specify file name
      let filename = this.proposal.requestsCode + ".doc";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    },
    removeCommercialization() {
      this.removeLoading = true;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/request/postDoc/removeCommercializing",
          {
            requestId: this.$route.params.id,
            description: this.proposal.removeDescription,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        ) // REVIEW
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.onMounted();
            this.removeCommercializationDialog = false;
            this.removeLoading = false;
          }
        })
        .catch((err) => {
          this.removeLoading = false;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    editCommercialization() {
      this.$http
        .post(
          this.baseUrl + "/setad/admin/request/postDoc/changeAccelerator",
          {
            acceleratorId: this.newAcceleratorId,
            requestId: this.$route.params.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.editCommercializationDialog = false;
          this.newAcceleratorId = "";
          this.onMounted();
          this.toast(res.data, "success");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //haveContract() {
    //  if (this.fileItems.filter((x) => x.title == "قرارداد").length == 0) {
    //    this.fileItems.unshift({
    //      title: "قرارداد",
    //      date: moment(new Date()).format("jYYYY/jMM/jDD"),
    //    });
    //  }
    //},
    //dontHaveContract() {
    //  if (this.fileItems.filter((x) => x.title == "قرارداد").length != 0) {
    //    this.fileItems.splice(
    //      this.fileItems.indexOf(
    //        this.fileItems.filter((x) => x.title == "قرارداد")[0]
    //      ),
    //      1
    //    );
    //  }
    //},
    addReport() {
      // NOTE (m-addAchievment) to add achievements in the relevant sections
      this.reportItems.push({
        name: "گزارش " + Number(this.reportItems.length + 1),
        date: moment(new Date()).format("jYYYY/jMM/jDD"),
      });
    },
    removeReport(order) {
      // NOTE (m-delAchievment) to remove achievments in the relevant sections
      this.reportItems.splice(order, 1);
      const title = (
        <div>
          <h5>حذف گزارش</h5>
          <span>گزارش مورد نظر شما حذف شد</span>
        </div>
      );
      this.toast(title, "error");
    },
    addFile() {
      // NOTE (m-addAchievment) to add achievements in the relevant sections
      this.fileItems.push({
        title: "فایل " + Number(this.fileItems.length + 1),
        date: moment(new Date()).format("jYYYY/jMM/jDD"),
      });
    },
    removeFile(order) {
      // NOTE (m-delAchievment) to remove achievments in the relevant sections
      this.fileItems.splice(order, 1);
      const title = (
        <div>
          <h5>حذف فایل</h5>
          <span>فایل مورد نظر شما حذف شد</span>
        </div>
      );
      this.toast(title, "error");
    },
    getManagerInfo() {
      // NOTE (m-getManagerInfo) to get the proposal information and review details
      let rejectsPromise = this.$http.post(
        this.baseUrl + "/setad/manager/allrejections ",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        }
      );

      rejectsPromise.then((res3) => {
        this.rejectOptions.push(
          ...res3.data.map((x) => {
            return {
              code: x.id,
              label: x.name,
            };
          })
        );
      });
      this.$http
        .post(
          this.baseUrl + "/setad/manager/requestId",
          {
            projectId: this.$route.params.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          try {
            this.judgements = JSON.parse(res.data.project.judgements);
          } catch (error) {
            this.judgements = [];
          }

          try {
            this.reviewerData = JSON.parse(res.data.project.reviewer);
          } catch (error) {
            this.reviewerData = [];
          }

          this.comments = this.proposal.adminMessage
            ? this.proposal.adminMessage.description
            : "";
          this.proposal = res.data.project;

          this.selectedSituation = this.situationsOptions.find(({ text }) =>
            text.includes(this.proposal.status)
          ).id;
          this.initial = JSON.parse(res.data.project.initial);
          this.promises = JSON.parse(res.data.project.promises);

          this.executor = JSON.parse(res.data.project.secondStep);
          try {
            this.executor.universityJob = JSON.parse(
              JSON.parse(res.data.project.secondStep).universityJob
            );
          } catch (error) {
            this.executor.universityJob = "";
          }
          this.uploadedFiles = res.data.project.files;

          this.proposal.typeStudy = JSON.parse(this.proposal.type).studies;
          this.proposal.typeSystemicDevelopmental = JSON.parse(
            this.proposal.type
          ).development;
          this.proposal.typePractical = JSON.parse(
            this.proposal.type
          ).practical;
          this.proposal.zoneMedicine = JSON.parse(this.proposal.zone).zone1;
          this.proposal.zoneAgriculture = JSON.parse(this.proposal.zone).zone2;
          this.proposal.zoneEnvironment = JSON.parse(this.proposal.zone).zone3;
          this.proposal.zoneIndustrial = JSON.parse(this.proposal.zone).zone4;
          this.proposal.zoneBioComputing = JSON.parse(this.proposal.zone).zone5;
          this.proposal.zoneOther = JSON.parse(this.proposal.zone).zone6;

          this.proposal.proposal.otherUniversity = JSON.parse(
            res.data.project.description
          ).proposal.otherUniversity;
          this.proposal.otherMehvars = JSON.parse(
            res.data.project.description
          ).proposal.otherMehvars;

          let colleague = JSON.parse(res.data.project.thirdStep);
          this.colleague = colleague.length != 0 ? colleague[0] : {};
          this.specs = JSON.parse(res.data.project.fourthStep).specs;

          this.proposal.requestProducts = JSON.parse(
            res.data.project.fourthStep
          ).tables.proposal.requestProducts;

          this.proposal.gantData = JSON.parse(
            res.data.project.fourthStep
          ).tables.proposal.gantData;

          this.inventionItemMaster = JSON.parse(
            res.data.project.fourthStep
          ).tables.inventionItemMaster;

          this.proposal.personnelCosts = JSON.parse(
            res.data.project.fourthStep
          ).tables.proposal.personnelCosts;
          this.proposal.travelExpenses = JSON.parse(
            res.data.project.fourthStep
          ).tables.proposal.travelExpenses;
          this.proposal.purchases = JSON.parse(
            res.data.project.fourthStep
          ).tables.proposal.purchases;
          this.proposal.participationOrganizationBudget = JSON.parse(
            res.data.project.fourthStep
          ).tables.proposal.participationOrganizationBudget;
          this.proposal.otherCosts =
            JSON.parse(res.data.project.fourthStep).tables.proposal.otherCosts
              .length == 0
              ? this.proposal.otherCosts
              : JSON.parse(res.data.project.fourthStep).tables.proposal
                  .otherCosts;

          this.inventionItem = JSON.parse(
            res.data.project.fourthStep
          ).tables.inventionItem;

          this.DoiItem = JSON.parse(res.data.project.fourthStep).tables.DoiItem;
          this.show = false;

          this.config.height = this.proposal.gantData.length * 60 + 100;

          this.config.list.rows = new Object({});
          this.config.chart.items = new Object({});

          this.proposal.gantData.forEach((x, index) => {
            this.config.list.rows[JSON.stringify(index + 1)] = new Object({
              id: JSON.stringify(index + 1),
              label: x.description,
            });

            this.config.chart.items[JSON.stringify(index + 1)] = new Object({
              id: JSON.stringify(index + 1),
              rowId: JSON.stringify(index + 1),
              label: x.description,
              time: {
                start: new Date(
                  moment(x.startDate, "jYYYY/jMM/jDD").format("YYYY-MM-DD")
                ).getTime(),
                end: new Date(
                  moment(x.dueDate, "jYYYY/jMM/jDD").format("YYYY-MM-DD")
                ).getTime(),
              },
              style: {
                background: this.background[index],
              },
            });
          });
          this.acc++;

          if (this.acc > 2) {
            try {
              document.body.classList.toggle("sidebar-minimized");
              document.body.classList.toggle("brand-minimized");
              this.toast(
                "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
              );
            } catch {}
            this.$bvModal.hide("loading");
            this.isLoaded = true;
          }
          setTimeout(() => {
            // NOTE (m-setTimeout) to set timeout for 200 ms
            this.show = true;
          }, 200);

          // this.additionalFiles = JSON.parse(res.data.project.files);

          this.fileBusy = false;
        })
        .catch((err) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          console.log({ err });
        });
    },
    hideModal(type) {
      // NOTE (m-hideModal) to hide loading
      this.$refs[type].hide();
    },

    removeJudge(row) {
      // NOTE (m-removeJudge) to specify selected judgment
      this.selectedJudgement = row.item;
      this.$root.$emit("show::modal", "delJudge");
      this.$bvModal.show("delJudge");
    },
    delJudge() {
      // NOTE (m-delJudge) to delete judgment
      this.$http
        .post(
          this.baseUrl + "/setad/admin/request/expireReview",
          {
            reviewId: this.selectedJudgement.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.toast(res.data, "success");
          this.$bvModal.hide("delJudge");
          this.onMounted();
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    computedVariant(seed) {
      // REVIEW
      let variant = [
        "primary",
        "secondary",
        "success",
        "warning",
        "danger",
        "dark",
        "info",
        "light",
      ];
      return variant[seed % 8];
    },
    sendReview() {
      // NOTE (m-sendReview) to submit the judgment
      this.$http
        .post(
          this.baseUrl + "/setad/referee/addJudge",
          {
            judgeId: this.selectedJudgement.id,
            description: this.score,
            decision: this.refereeDecision,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            EventBus.$emit("refereeAdded", {});
            this.$router.replace("/referee/reviews");
          } else if (res.status == 202) {
            this.toast(res.data.text, "success");
            this.toast(res.data.error, "error");
            this.$router.replace("/referee/reviews");
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            this.$router.push({
              path: "/unauthorize",
              query: { return: window.location.pathname },
            });
          }
        });

      this.fileBusy = false;
    },
    editProposal(status) {
      // NOTE (m-editProposal) to submit proposal changes
      this.$bvModal.show("loading");

      if (status == "inviteReviewers") {
        this.$http
          .post(
            this.baseUrl + "/setad/admin/request/postDoc/" + status,
            {
              requestId: this.$route.params.id,
              description: this.proposal.description,
              referees: this.reviewers,
              adminToReferee: this.proposal.adminToReferee,
              isAccelerator: this.proposal.isAccelerator,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          ) // REVIEW
          .then((res) => {
            this.proposal.status = this.situationsOptions.filter(
              (x) => x.id == this.selectedSituation
            )[0].text;
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            if (res.status == 200) {
              this.$router.push("/admin/activePostDocs");
              setTimeout(() => {
                this.proposal.description = "";
                this.proposal.adminToReferee = "";
                this.reviewers = [];
              }, 300);
              this.toast(res.data, "success");
            }
          })
          .catch((err) => {
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            console.log(err);
            this.toast(err.response.data, "error");
          });
      } else if (status == "finalAccept") {
        this.$http
          .post(
            this.baseUrl + "/setad/admin/request/postDoc/" + status,
            {
              requestId: this.$route.params.id,
              contract: this.contract,
              isReferee: this.haveReferee,
              isAccelerator: this.isAccelerator,
              reports: this.reportItems,
              pcFiles: this.fileItems,
              refereeId: this.selectedReferee,
              adminMessage: this.adminMessage,
              description: this.proposal.description,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          ) // REVIEW
          .then((res) => {
            this.proposal.status = this.situationsOptions.filter(
              (x) => x.id == this.selectedSituation
            )[0].text;
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            if (res.status == 200) {
              this.$router.push("/admin/decidedPostDocs");
              setTimeout(() => {
                this.proposal.description = "";
                this.proposal.adminToReferee = "";
                this.reviewers = [];
              }, 300);
              this.toast(res.data, "success");
            }
          })
          .catch((err) => {
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            console.log(err);
            this.toast(err.response.data, "error");
          });
      } else if (status == "reject") {
        this.$http
          .post(
            this.baseUrl + "/setad/admin/request/postDoc/" + status,
            {
              requestId: this.$route.params.id,
              rejectionIds: this.proposal.rejectionIds,
              description: this.proposal.description,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          ) // REVIEW
          .then((res) => {
            this.proposal.status = this.situationsOptions.filter(
              (x) => x.id == this.selectedSituation
            )[0].text;
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            if (res.status == 200) {
              this.$router.push("/admin/canceledPostDocs");
              setTimeout(() => {
                this.proposal.description = "";
                this.proposal.adminToReferee = "";
                this.reviewers = [];
              }, 300);
              this.toast(res.data, "success");
            }
          })
          .catch((err) => {
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            console.log(err);
            this.toast(err.response.data, "error");
          });
      } else {
        this.$http
          .post(
            this.baseUrl + "/setad/admin/request/postDoc/" + status,
            {
              requestId: this.$route.params.id,
              description: this.proposal.description,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          ) // REVIEW
          .then((res) => {
            this.proposal.status = this.situationsOptions.filter(
              (x) => x.id == this.selectedSituation
            )[0].text;
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            if (res.status == 200) {
              setTimeout(() => {
                this.proposal.description = "";
                this.proposal.adminToReferee = "";
                this.reviewers = [];
              }, 300);
              this.toast(res.data, "success");
              if (this.selectedSituation == 8) {
                this.$router.push("/admin/needEditPostDocs");
              } else {
                this.$router.push("/admin/activePostDocs");
              }
            }
          })
          .catch((err) => {
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            console.log(err);
            this.toast(err.response.data, "error");
          });
      }
    },
    submitComment() {
      this.$http
        .post(
          this.baseUrl + "/setad/admin/editRequestId",
          {
            projectId: this.$route.params.id,
            projectType: "postDoc",
            description: JSON.stringify({
              description: this.comments,
              score: this.score,
            }),
            rejection_id: JSON.stringify(this.rejectCause),
            situation: this.situationsOptions.filter(
              (x) => x.id == this.selectedSituation
            )[0].eng,
            referees:
              this.reviewersData.length > 1
                ? String(this.reviewersData)
                : this.reviewersData.length
                ? String(this.reviewersData[0])
                : "",
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        ) // REVIEW
        .then((res) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          if (res.status == 200) {
            this.acc = 2;
            setTimeout(() => {
              this.showProject();
            }, 300);
            this.comments = "";
            this.toast(res.data, "success");
          }
        })
        .catch((err) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    editProposalManager() {
      // NOTE (m-editProposalManager) to submit reason for rejection
      this.$bvModal.show("loading");
      this.isLoaded = false;
      // this.disableEditProposal = true;
      let editProposal = this.$http.post(
        this.baseUrl + "/setad/manager/confirmationRequestId",
        {
          projectId: this.$route.params.id,
          projectType: "postDoc",
          rejection_id: JSON.stringify(this.rejectCause),
          situation: this.selectedSituation,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        }
      );

      editProposal // REVIEW
        .then((res) => {
          this.proposal.status = this.selectedSituation;
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.$router.push("/manager/needPostDocs");
          }
        })
        .catch((err) => {
          this.getManagerInfo();
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    showProject() {
      if (this.role == "researcher") {
        let rejectsPromise = this.$http.post(
          this.baseUrl + "/setad/researcher/allrejections ",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        );

        rejectsPromise.then((res3) => {
          this.rejectOptions.push(
            ...res3.data.map((x) => {
              return {
                code: x.id,
                label: x.name,
              };
            })
          );
        });
      } else if (this.role == "manager") {
        this.getManagerInfo();
      }
    },
    onMounted() {
      // NOTE (MOUNTED) to show the data of this page
      this.$bvModal.show("loading");
      this.isLoaded = false;
      this.$root.$emit("show::modal", "loading");

      this.busyAll = true;

      this.fileBusy = false;
       // rejections
        this.$http
          .post(
            this.baseUrl + "/setad/options/rejections",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.rejectOptions = res.data;
            this.rejectOptions.forEach((x) => {
              x.code = x.id;
              x.label = x.name;
            });

            acc++;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
      if (this.role == "admin") {
        let acc = 0;
        // admin universities
        this.$http
          .post(
            this.baseUrl + "/setad/options/universities",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.universities = res.data;
            this.universities.push(
              new Object({
                id: this.notUniversity,
                text: "سایر دانشگاه ها",
              })
            );
            this.universities.unshift({
              id: 0,
              name: "--گزینه مورد نظر خود را انتخاب نمایید--",
              disabled: "true",
            });
            acc++;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
        /////////////////////////////////////////////
        // admin mehvars
        this.$http
          .post(
            this.baseUrl + "/setad/options/uniMehvars",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.mehvars = res.data;
            acc++;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
        /////////////////////////////////////////////
        // admin companies
        this.$http
          .post(
            this.baseUrl + "/setad/options/companies",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.companies = res.data;
            this.companies.forEach((x) => {
              x.text = x.name;
            });
            this.companies.push(
              new Object({
                id: this.notCompany,
                text: "سایر شرکت ها",
              })
            );

            acc++;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
        /////////////////////////////////////////////
        // admin reviewers
        this.$http
          .post(
            this.baseUrl + "/setad/admin/reviewers/select",
            {
              projectId: this.$route.params.id,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.reviewersOptions = res.data;
            this.reviewersOptions.forEach((x) => {
              x.code = x.id;
              x.label = x.name;
            });

            acc++;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
        /////////////////////////////////////////////
        //////////////////////////////////////
        // admin getInfo
        this.$http
          .post(
            this.baseUrl + "/setad/admin/request/postDoc/getInfo",
            {
              requestId: this.$route.params.id,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.proposal = res.data.request;
            this.reviews = res.data.reviews;
            this.selectedSituation = this.situationsOptions.filter(
              (x) => x.text == this.proposal.status
            )[0].id;
            acc++;
            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
              this.$bvModal.hide("loading");
              this.isLoaded = true;
            }
            setTimeout(() => {
              // NOTE (m-setTimeout) to set timeout for 200 ms
              this.pageLoaded = true;
            }, 200);
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
      } else if (this.role == "researcher") {
        let acc = 0;

        //getting info
        this.$http
          .post(
            this.baseUrl + "/setad/researcher/request/postDoc/getInfo",
            {
              requestId: this.$route.params.id,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.proposal = res.data;
            !this.proposal.supervisors.length
              ? (this.proposal.supervisors = [
                  {
                    id: "",
                    name: "",
                    lastName: "",
                    mobile: "",
                    natCode: "",
                    email: "",
                    position: "",
                    lastDegree: "",
                    universityId: "",
                    UniversityOther: "",
                    universityJobId: "",
                    UniversityJobOther: "",
                    phdThesisSubject: "",
                    academicRank: "",
                    scienceCommitteeType: "",
                    article: "",
                    resumeFileId: "",
                    resumeFile: "",
                    doi1: "",
                    doi2: "",
                    doi3: "",
                    doi4: "",
                    doi5: "",
                    internationalPatent: "",
                    internationalPatentTitle: "",
                    internationalPatentYear: "",
                    internationalPatentDescription: "",
                    researchFestivals: "",
                    researchFestivalsTitle: "",
                    notSupervisor: "",
                  },
                ])
              : (this.proposal.supervisors = res.data.supervisors);
            acc++;

            setTimeout(() => {
              // NOTE (m-setTimeout) to set timeout for 200 ms
              this.pageLoaded = true;
            }, 200);

            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
              this.$bvModal.hide("loading");
              this.isLoaded = true;
            }

            this.fileBusy = false;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            console.log(err);
            this.toast(err.response.data, "error");
          });

        this.$bvModal.show("loading");
        this.isLoaded = false;

        // getting all universities
        this.$http
          .post(
            this.baseUrl + "/setad/options/universities",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.universities = res.data;
            this.universities.push(
              new Object({
                id: this.notUniversity,
                text: "سایر دانشگاه ها",
              })
            );
            this.universities.unshift({
              id: 0,
              text: "--گزینه مورد نظر خود را انتخاب نمایید--",
              disabled: "true",
            });
            this.$bvModal.hide("loading");
            this.isLoaded = true;

            acc++;

            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });

        //getting companies
        this.$http
          .post(
            this.baseUrl + "/setad/options/companies",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.companies = res.data;
            this.companies.forEach((x) => {
              x.text = x.name;
            });
            this.companies.push(
              new Object({
                id: this.notCompany,
                text: "سایر شرکت‌ها",
              })
            );
            this.companies.unshift({
              id: 0,
              text: "--گزینه مورد نظر خود را انتخاب نمایید--",
              disabled: "true",
            });
            this.$bvModal.hide("loading");
            this.isLoaded = true;

            acc++;

            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });

        // getting all mehvars
        this.$http
          .post(
            this.baseUrl + "/setad/options/uniMehvars",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.mehvars = res.data;
            acc++;

            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
              this.$bvModal.hide("loading");
              this.isLoaded = true;
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
      } else if (this.role == "referee") {
        let acc = 0;
        // referee universities
        this.$http
          .post(
            this.baseUrl + "/setad/options/universities",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.universities = res.data;
            this.universities.push(
              new Object({
                id: this.notUniversity,
                text: "سایر دانشگاه ها",
              })
            );
            this.universities.unshift({
              id: 0,
              text: "--گزینه مورد نظر خود را انتخاب نمایید--",
              disabled: "true",
            });

            acc++;

            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");

                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
        /////////////////////////////////////////////
        // referee mehvars
        this.$http
          .post(
            this.baseUrl + "/setad/options/uniMehvars",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.mehvars = res.data;
            acc++;

            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });

        /////////////////////////////////////////////
        // referee companies
        this.$http
          .post(
            this.baseUrl + "/setad/options/companies",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.companies = res.data;
            this.companies.forEach((x) => {
              x.text = x.name;
            });
            this.companies.push(
              new Object({
                id: this.notCompany,
                text: "سایر شرکت ها",
              })
            );
            acc++;

            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
        //////////////////////////////////////
        // referee getInfo
        this.$http
          .post(
            this.baseUrl + "/setad/reviewer/review/postDoc/getInfo",
            {
              reviewId: this.$route.params.judgeId,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.proposal = res.data.request;
            this.proposal.adminToReferee = res.data.adminToReferee;

            this.acc++;
            this.$bvModal.hide("loading");
            this.pageLoaded = true;
            this.isLoaded = true;
            if (this.acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
            }
            setTimeout(() => {
              // NOTE (m-setTimeout) to set timeout for 200 ms
              this.show = true;
            }, 200);

            this.fileBusy = false;
          })
          .catch((err) => {
            this.refereeErrorHandler = true;
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            console.log(err);
            this.toast(err.response.data, "error");
          });
      } else if (this.role == "manager") {
        let allUniMehvars = this.$http.post(
          this.baseUrl + "/setad/manager/allUniMehvarsBoth",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        );
        let allUniversities = this.$http.post(
          this.baseUrl + "/setad/manager/allUniversities",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        );

        Promise.all([allUniMehvars, allUniversities]).then((res) => {
          let allMehv = res[0].data;
          let allUni = res[1].data;

          this.acc++;
          this.progressValue += 30;
          if (this.acc > 2) {
            this.$bvModal.hide("loading");
            this.isLoaded = true;

            this.busyAll = false;
          }
          this.mehvars = allMehv;
          this.mehvars.push(
            new Object({
              id: this.notMehvar,
              text: "سایر محورها",
              universityId: this.notUniversity,
            })
          );

          this.acc++;
          this.progressValue += 30;
          if (this.acc > 2) {
            this.$bvModal.hide("loading");
            this.isLoaded = true;

            this.busyAll = false;
          }
          this.universities = allUni;
          this.universities.push(
            new Object({
              id: this.notUniversity,
              text: "سایر دانشگاه‌ها",
            })
          );
        });
      } else if (this.role == "head") {
        let acc = 0;

        // head universities
        this.$http
          .post(
            this.baseUrl + "/setad/options/universities",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.universities = res.data;
            this.universities.push(
              new Object({
                id: this.notUniversity,
                text: "سایر دانشگاه ها",
              })
            );
            this.universities.unshift({
              id: 0,
              name: "--گزینه مورد نظر خود را انتخاب نمایید--",
              disabled: "true",
            });
            acc++;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
        /////////////////////////////////////////////
        // head mehvars
        this.$http
          .post(
            this.baseUrl + "/setad/options/uniMehvars",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.mehvars = res.data;

            acc++;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
        /////////////////////////////////////////////
        // head companies
        this.$http
          .post(
            this.baseUrl + "/setad/options/companies",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.companies = res.data;
            this.companies.forEach((x) => {
              x.text = x.name;
            });
            this.companies.push(
              new Object({
                id: this.notCompany,
                text: "سایر شرکت ها",
              })
            );

            acc++;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
        /////////////////////////////////////////////
        // head reviewers
        this.$http
          .post(
            this.baseUrl + "/setad/head/reviewers/select",
            {
              projectId: this.$route.params.id,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.reviewersOptions = res.data;
            this.reviewersOptions.forEach((x) => {
              x.code = x.id;
              x.label = x.name;
            });

            acc++;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
        //////////////////////////////////////
        // head getInfo

        this.fileBusy = false;
        this.$http
          .post(
            this.baseUrl + "/setad/head/request/postDoc/getInfo",
            {
              requestId: this.$route.params.id,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.proposal = res.data.request;
            this.files = res.data.uploadedFiles;
            acc++;
            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
              this.$bvModal.hide("loading");
              this.pageLoaded = true;
              this.isLoaded = true;
            }
            setTimeout(() => {
              // NOTE (m-setTimeout) to set timeout for 200 ms
            }, 200);

            this.fileBusy = false;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.notLoaded = true;
            console.log(err);
            this.toast(err.response.data, "error");
          });
      } else if (this.role == "university") {
        let acc = 0;

        //getting info
        this.$http
          .post(
            this.baseUrl + "/setad/university/request/postDoc/getInfo",
            {
              requestId: this.$route.params.id,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.proposal = res.data;
            !this.proposal.supervisors.length
              ? (this.proposal.supervisors = [
                  {
                    id: "",
                    name: "",
                    lastName: "",
                    mobile: "",
                    natCode: "",
                    email: "",
                    position: "",
                    lastDegree: "",
                    universityId: "",
                    UniversityOther: "",
                    universityJobId: "",
                    UniversityJobOther: "",
                    phdThesisSubject: "",
                    academicRank: "",
                    scienceCommitteeType: "",
                    article: "",
                    resumeFileId: "",
                    resumeFile: "",
                    doi1: "",
                    doi2: "",
                    doi3: "",
                    doi4: "",
                    doi5: "",
                    internationalPatent: "",
                    internationalPatentTitle: "",
                    internationalPatentYear: "",
                    internationalPatentDescription: "",
                    researchFestivals: "",
                    researchFestivalsTitle: "",
                    notSupervisor: "",
                  },
                ])
              : (this.proposal.supervisors = res.data.supervisors);
            acc++;

            setTimeout(() => {
              // NOTE (m-setTimeout) to set timeout for 200 ms
              this.pageLoaded = true;
            }, 200);

            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
              this.$bvModal.hide("loading");
              this.isLoaded = true;
            }

            this.fileBusy = false;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            console.log(err);
            this.toast(err.response.data, "error");
          });

        this.$bvModal.show("loading");
        this.isLoaded = false;

        // getting all universities
        this.$http
          .post(
            this.baseUrl + "/setad/options/universities",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.universities = res.data;
            this.universities.push(
              new Object({
                id: this.notUniversity,
                text: "سایر دانشگاه ها",
              })
            );
            this.universities.unshift({
              id: 0,
              text: "--گزینه مورد نظر خود را انتخاب نمایید--",
              disabled: "true",
            });
            this.$bvModal.hide("loading");
            this.isLoaded = true;

            acc++;

            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });

        //getting companies
        this.$http
          .post(
            this.baseUrl + "/setad/options/companies",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.companies = res.data;
            this.companies.forEach((x) => {
              x.text = x.name;
            });
            this.companies.push(
              new Object({
                id: this.notCompany,
                text: "سایر شرکت‌ها",
              })
            );
            this.companies.unshift({
              id: 0,
              text: "--گزینه مورد نظر خود را انتخاب نمایید--",
              disabled: "true",
            });
            this.$bvModal.hide("loading");
            this.isLoaded = true;

            acc++;

            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });

        // getting all mehvars
        this.$http
          .post(
            this.baseUrl + "/setad/options/uniMehvars",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.mehvars = res.data;
            acc++;

            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
              this.$bvModal.hide("loading");
              this.isLoaded = true;
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
      }

      //get accelerators
      this.$http
        .post(
          this.baseUrl + "/setad/options/accelerators",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.accelerators = res.data;
          this.accelerators.forEach((x) => {
            x.text = x.name;
          });
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
      this.showProject();
    },
  },
  computed: {
    computedSelectedReferees() {
      let referees = this.reviewersOptions.filter(
        (x) => this.reviewers.indexOf(x.code) != -1
      );
      return referees;
    },
    computedSelectedReferees2() {
      let referees = this.reviewersOptions.filter(
        (x) => this.selectedReferee.indexOf(x.code) != -1
      );
      return referees;
    },

    computedTotalCost() {
      let tempPrice =
        (this.proposal.personnelCosts.length == 0
          ? 0
          : this.proposal.personnelCosts
              .map(
                (x) => parseInt(x.perPersonCost) * parseInt(x.cooperationHour)
              )
              .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
        (this.proposal.travelExpenses.length == 0
          ? 0
          : this.proposal.travelExpenses
              .map((x) => x.cost)
              .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
        (this.proposal.purchases.length == 0
          ? 0
          : this.proposal.purchases
              .map((x) => parseInt(x.perPrice) * parseInt(x.number))
              .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
        (this.proposal.otherCosts.length == 0
          ? 0
          : this.proposal.otherCosts
              .map((x) => x.totalPrice)
              .reduce((a, b) => parseInt(a) + parseInt(b), 0)) -
        (this.proposal.participationOrganizationBudget.length == 0
          ? 0
          : this.proposal.participationOrganizationBudget
              .map((x) => x.totalPrice)
              .reduce((a, b) => parseInt(a) + parseInt(b), 0));

      if (tempPrice > 0) return tempPrice;
      else return 0;
    },
    computedJournals() {
      if (this.proposal.history) {
        return this.proposal.history.sort((a, b) => {
          if (a.timeStamp < b.timeStamp) {
            return 1;
          }
          if (a.timeStamp > b.timeStamp) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
      } else return [];
    },
    computedJudgements() {
      if (this.proposal.judgements) {
        this.proposal.judgements.forEach((element) => {
          this.$set(element, "_showDetails", false);
          this.$set(element, "isActive", false);
        });

        return this.proposal.judgements;
      } else return [];
    },
    disableEditProposal() {
      if (this.selectedSituation) {
        if (this.selectedSituation == 8) {
          if (!this.proposal.description) {
            return true;
          } else return false;
        }
        if (this.selectedSituation == 7) {
          if (
            this.contract == null ||
            this.haveReferee == null ||
            !this.reportItems.length
          ) {
            return true;
          } else if (this.haveReferee && this.selectedReferee.length == 0) {
            return true;
          } else return false;
        }
        if (this.selectedSituation == 3 && this.reviewers.length == 0)
          return true;
        if (this.selectedSituation == 9 && !this.proposal.rejectionIds.length)
          return true;
        if (this.selectedSituation == 10 && !this.proposal.description)
          return true;
        return false;
      } else return true;
    },
  },
  mounted() {
    setTimeout(() => {
      if (!this.isLoaded) {
        const title = (
          <div>
            <h5 class="text-center">...کندی سرعت اینترنت</h5>
            <span>
              به نظر میرسد سرعت اینترنت شما کمی کند است. لطفا برای بارگذاری
              اطلاعات بیشتر صبر کنید یا صفحه را رفرش کنید
            </span>
          </div>
        );
        this.toast(title, "warning");
        this.$bvModal.hide("loading");
      }
    }, this.isLoadedTimeOut);
    this.showProject();
    this.onMounted();
  },
  updated() {},
};
</script>
<style lang="scss">
.selected-referees {
  border: 1px solid grey;
  border-radius: 5px;
  margin-bottom: 10px;
  &__tags {
    border: 1px solid grey;
    border-radius: 5px;
    padding: 8px 12px;
    .tag {
      padding: 5px;
      margin: 5px;
    }
  }
}
</style>
<style lang="scss" scoped>
.color {
  background-color: #0c4961;
  color: white;
}

.select2-container {
  width: 100% !important;
  padding: 0;
}

.select2 {
  width: 100% !important;
}

select {
  min-width: max-content;
  width: 100%;
}

.required {
  color: red;
}

.done {
  color: green;
}
.btn-dark {
  h5 {
    color: #fff !important;
  }
  background-color: #4b285d !important;
  border-color: #4b285d !important;
}
.btn-light {
  h5 {
    color: #fff !important;
  }
  background-color: #63317c !important;
  border-color: #63317c !important;
}
.btn-warning {
  h5 {
    color: #fff !important;
  }
  background-color: #8341a4 !important;
  border-color: #8341a4 !important;
}
.btn-info {
  h5 {
    color: #fff !important;
  }
  background-color: #a557cb !important;
  border-color: #a557cb !important;
}
.btn:hover {
  h5 {
    color: #fff !important;
  }
  background-color: #999999 !important;
  border-color: #b173a2 !important;
}

.table-column {
  min-width: 100px;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #8341a4;
  border-bottom: 1px solid #8341a4;
}
.btn-secondary {
  background-color: #83819b;
  border-color: #9b8195;
}

#vs1__listbox {
  text-align: right;
  direction: rtl;
}
</style>
<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
strong {
  color: #fff !important;
}
</style></style>
